webpackJsonp([2345137460201621000,17463659626562118000,4798610687222769000],{

/***/ "./node_modules/is-equal-shallow/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-equal-shallow <https://github.com/jonschlinkert/is-equal-shallow>
	 *
	 * Copyright (c) 2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var isPrimitive = __webpack_require__("./node_modules/is-primitive/index.js");
	
	module.exports = function isEqual(a, b) {
	  if (!a && !b) { return true; }
	  if (!a && b || a && !b) { return false; }
	
	  var numKeysA = 0, numKeysB = 0, key;
	  for (key in b) {
	    numKeysB++;
	    if (!isPrimitive(b[key]) || !a.hasOwnProperty(key) || (a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (key in a) {
	    numKeysA++;
	  }
	  return numKeysA === numKeysB;
	};


/***/ }),

/***/ "./node_modules/is-primitive/index.js":
/***/ (function(module, exports) {

	/*!
	 * is-primitive <https://github.com/jonschlinkert/is-primitive>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	// see http://jsperf.com/testing-value-is-primitive/7
	module.exports = function isPrimitive(value) {
	  return value == null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),

/***/ "./node_modules/lodash/_arrayAggregator.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ }),

/***/ "./node_modules/lodash/_baseAggregator.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js");
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ }),

/***/ "./node_modules/lodash/_createAggregator.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__("./node_modules/lodash/_arrayAggregator.js"),
	    baseAggregator = __webpack_require__("./node_modules/lodash/_baseAggregator.js"),
	    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ }),

/***/ "./node_modules/lodash/keyBy.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
	    createAggregator = __webpack_require__("./node_modules/lodash/_createAggregator.js");
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ }),

/***/ "./node_modules/popper.js/dist/umd/popper.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.11.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var nativeHints = ['native code', '[object MutationObserverConstructor]'];
	
	/**
	 * Determine if a function is implemented natively (as opposed to a polyfill).
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Function | undefined} fn the function to check
	 * @returns {Boolean}
	 */
	var isNative = (function (fn) {
	  return nativeHints.some(function (hint) {
	    return (fn || '').toString().indexOf(hint) > -1;
	  });
	});
	
	var isBrowser = typeof window !== 'undefined';
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var scheduled = false;
	  var i = 0;
	  var elem = document.createElement('span');
	
	  // MutationObserver provides a mechanism for scheduling microtasks, which
	  // are scheduled *before* the next task. This gives us a way to debounce
	  // a function but ensure it's called *before* the next paint.
	  var observer = new MutationObserver(function () {
	    fn();
	    scheduled = false;
	  });
	
	  observer.observe(elem, { attributes: true });
	
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      elem.setAttribute('x-index', i);
	      i = i + 1; // don't use compund (+=) because it doesn't get optimized in V8
	    }
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	// It's common for MutationObserver polyfills to be seen in the wild, however
	// these rely on Mutation Events which only occur when an element is connected
	// to the DOM. The algorithm used in this module does not use a connected element,
	// and so we must ensure that a *native* MutationObserver is available.
	var supportsNativeMutationObserver = isBrowser && isNative(window.MutationObserver);
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsNativeMutationObserver ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element || ['HTML', 'BODY', '#document'].indexOf(element.nodeName) !== -1) {
	    return window.document.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  // NOTE: 1 DOM access here
	  var offsetParent = element && element.offsetParent;
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return window.document.documentElement;
	  }
	
	  // .offsetParent will return the closest TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return window.document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = window.document.documentElement;
	    var scrollingElement = window.document.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return +styles['border' + sideA + 'Width'].split('px')[0] + +styles['border' + sideB + 'Width'].split('px')[0];
	}
	
	/**
	 * Tells if you are running Internet Explorer 10
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean} isIE10
	 */
	var isIE10 = undefined;
	
	var isIE10$1 = function () {
	  if (isIE10 === undefined) {
	    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
	  }
	  return isIE10;
	};
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], html['client' + axis], html['offset' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
	}
	
	function getWindowSizes() {
	  var body = window.document.body;
	  var html = window.document.documentElement;
	  var computedStyle = isIE10$1() && window.getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  if (isIE10$1()) {
	    try {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } catch (err) {}
	  } else {
	    rect = element.getBoundingClientRect();
	  }
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var isIE10 = isIE10$1();
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = +styles.borderTopWidth.split('px')[0];
	  var borderLeftWidth = +styles.borderLeftWidth.split('px')[0];
	
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = +styles.marginTop.split('px')[0];
	    var marginLeft = +styles.marginLeft.split('px')[0];
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var html = window.document.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = getScroll(html);
	  var scrollLeft = getScroll(html, 'left');
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  // NOTE: 1 DOM access here
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(popper));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = window.document.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = window.document.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  boundaries.left += padding;
	  boundaries.top += padding;
	  boundaries.right -= padding;
	  boundaries.bottom -= padding;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var commonOffsetParent = findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier.function) {
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier.function || modifier.fn;
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	  data.offsets.popper.position = 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length - 1; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof window.document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroy the popper
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.left = '';
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? window : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  window.addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  window.removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger onUpdate callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    window.cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if the arrow style has been computed, apply the arrow style
	  if (data.offsets.arrow) {
	    setStyles(data.arrowElement, data.offsets.arrow);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper.
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // floor sides to avoid blurry text
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.floor(popper.top),
	    bottom: Math.floor(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    top = -offsetParentRect.height + offsets.bottom;
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    left = -offsetParentRect.width + offsets.right;
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update attributes and styles of `data`
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var side = isVertical ? 'top' : 'left';
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  var sideValue = center - getClientRect(data.offsets.popper)[side];
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = {};
	  data.offsets.arrow[side] = Math.round(sideValue);
	  data.offsets.arrow[altSide] = ''; // make sure to unset any eventual altSide value from the DOM node
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-right` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[placement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unitless, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the height.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * An scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper this makes sure the popper has always a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier, can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near eachothers
	   * without leaving any gap between the two. Expecially useful when the arrow is
	   * enabled and you want to assure it to point to its reference element.
	   * It cares only about the first axis, you can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjuction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations).
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position,
	     * the popper will never be placed outside of the defined boundaries
	     * (except if keepTogether is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define you own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the informations used by Popper.js
	 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overriden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass as 3rd argument an object with the same
	 * structure of this object, example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Whether events (resize, scroll) are initially enabled
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated, this callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Create a new Popper.js instance
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper.
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference.jquery ? reference[0] : reference;
	    this.popper = popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedule an update, it will run on the next UI update available
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/react-popper/lib/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Arrow;

/***/ }),

/***/ "./node_modules/react-popper/lib/Manager.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manager = function (_Component) {
	  _inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = _objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return (0, _react.createElement)(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	
	  return Manager;
	}(_react.Component);
	
	Manager.childContextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Manager.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	exports.default = Manager;

/***/ }),

/***/ "./node_modules/react-popper/lib/Popper.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _popper = __webpack_require__("./node_modules/popper.js/dist/umd/popper.js");
	
	var _popper2 = _interopRequireDefault(_popper);
	
	var _isEqualShallow = __webpack_require__("./node_modules/is-equal-shallow/index.js");
	
	var _isEqualShallow2 = _interopRequireDefault(_isEqualShallow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {
	  return null;
	};
	
	var Popper = function (_Component) {
	  _inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      return _this.context.popperManager.getTargetNode();
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this.state.data && !(0, _isEqualShallow2.default)(data.offsets, _this.state.data.offsets) || !_this.state.data) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	      // If Popper isn't instantiated, hide the popperElement
	      // to avoid flash of unstyled content
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      var _data$offsets$popper = data.offsets.popper,
	          top = _data$offsets$popper.top,
	          left = _data$offsets$popper.left,
	          position = _data$offsets$popper.position;
	
	
	      return _extends({
	        position: position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return !!_this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updatePopper();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
	        this._updatePopper();
	      }
	
	      if (this._popper && lastProps.children !== this.props.children) {
	        this._popper.scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_updatePopper',
	    value: function _updatePopper() {
	      this._destroyPopper();
	      if (this._node) {
	        this._createPopper();
	      }
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	
	      if (this._arrowNode) {
	        modifiers.arrow = {
	          element: this._arrowNode
	        };
	      }
	
	      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // schedule an update to make sure everything gets positioned correct
	      // after being instantiated
	      this._popper.scheduleUpdate();
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperRef = function popperRef(node) {
	        _this2._node = node;
	        if (typeof innerRef === 'function') {
	          innerRef(node);
	        }
	      };
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	
	      if (typeof children === 'function') {
	        var popperProps = _defineProperty({
	          ref: popperRef,
	          style: popperStyle
	        }, 'data-placement', popperPlacement);
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._popper && this._popper.scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = popperRef;
	      } else {
	        componentProps.innerRef = popperRef;
	      }
	
	      return (0, _react.createElement)(component, componentProps, children);
	    }
	  }]);
	
	  return Popper;
	}(_react.Component);
	
	Popper.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Popper.childContextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	Popper.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  placement: _propTypes2.default.oneOf(_popper2.default.placements),
	  eventsEnabled: _propTypes2.default.bool,
	  modifiers: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	exports.default = Popper;

/***/ }),

/***/ "./node_modules/react-popper/lib/Target.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	
	Target.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Target;

/***/ }),

/***/ "./node_modules/react-popper/lib/react-popper.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;
	
	var _Manager2 = __webpack_require__("./node_modules/react-popper/lib/Manager.js");
	
	var _Manager3 = _interopRequireDefault(_Manager2);
	
	var _Target2 = __webpack_require__("./node_modules/react-popper/lib/Target.js");
	
	var _Target3 = _interopRequireDefault(_Target2);
	
	var _Popper2 = __webpack_require__("./node_modules/react-popper/lib/Popper.js");
	
	var _Popper3 = _interopRequireDefault(_Popper2);
	
	var _Arrow2 = __webpack_require__("./node_modules/react-popper/lib/Arrow.js");
	
	var _Arrow3 = _interopRequireDefault(_Arrow2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Manager = _Manager3.default;
	exports.Target = _Target3.default;
	exports.Popper = _Popper3.default;
	exports.Arrow = _Arrow3.default;

/***/ }),

/***/ "./src/components/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // http://thenewcode.com/1068/Making-Arrows-in-SVG
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolyLineStyle = {
	  fill: 'none',
	  stroke: '#231F20',
	  //vectorEffect: 'non-scaling-stroke',
	  strokeWidth: 2
	};
	
	var PathStyle = _extends({}, PolyLineStyle, {
	  strokeDasharray: '11, 5'
	});
	
	function toRad(d) {
	  return d * Math.PI / 180;
	}
	
	var Arrow = function (_PureComponent) {
	  _inherits(Arrow, _PureComponent);
	
	  function Arrow() {
	    _classCallCheck(this, Arrow);
	
	    var _this = _possibleConstructorReturn(this, (Arrow.__proto__ || Object.getPrototypeOf(Arrow)).call(this));
	
	    if (!_this.constructor.__counter) {
	      _this.constructor.__counter = 1;
	    }
	    _this.uniqid = _this.constructor.__counter++;
	    return _this;
	  }
	
	  _createClass(Arrow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          length = _props.length,
	          angle = _props.angle,
	          otherProps = _objectWithoutProperties(_props, ['length', 'angle']);
	
	      // By default, our sin math would let the angle rotate to
	      // the left. Reverse the direction.
	
	
	      angle = -angle + 180;
	      angle = angle % 360;
	
	      // Let's do some trig to calculate the viewbox.
	      //
	      // Assuming the arrow points top right, c is the arrow
	      // length, a is the viewbox width, b is the viewbox height.
	
	      // We know C is 90deg
	      var B = angle;
	      var C = 90;
	      var A = 180 - C - B;
	      var c = length;
	
	      // Get all the sides
	      var a = c / Math.sin(toRad(C)) * Math.sin(toRad(A));
	      var b = c / Math.sin(toRad(C)) * Math.sin(toRad(B));
	
	      // a, b can be negative if the angle. We will rewrite
	      // those values to go inside the svg viewbox.
	      var width = Math.abs(b);
	      var height = Math.abs(a);
	
	      var padding = 10;
	
	      // Now we have a viewBox
	      var viewBox = '0 0 ' + (width + padding * 2) + ' ' + (height + padding * 2);
	
	      function point(x, y) {
	        if (b < 0) {
	          x = width + padding * 2 - x;
	        }
	        if (a < 0) {
	          y = height + padding * 2 - y;
	        }
	        return x + ',' + y;
	      }
	
	      var path = ['M' + point(padding, padding), 'L' + point(width + padding, height + padding)];
	
	      // TODO: Cooler line:
	      // M16.7,178 c87.6-46.9,162.9-185.4,227-136.4C307.2,90.1,195,158.5,111,108.9C71,85.2,92.2,30.7,126,7
	
	      var markerId = 'Arrow-pointer-' + this.uniqid;
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({
	          xmlns: 'http://www.w3.org/2000/svg',
	          viewBox: viewBox
	        }, otherProps),
	        _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'marker',
	            {
	              id: markerId,
	              markerWidth: '9',
	              markerHeight: '9',
	              refX: '8',
	              refY: '5',
	              orient: 'auto',
	              markerUnits: 'strokeWidth' },
	            _react2.default.createElement('polyline', {
	              points: '1 1, 9 5, 1 9',
	              style: { PolyLineStyle: PolyLineStyle }
	            })
	          )
	        ),
	        _react2.default.createElement('path', {
	          style: PathStyle,
	          d: path.join(' '),
	          markerEnd: 'url(#' + markerId + ')'
	        })
	      );
	    }
	  }]);
	
	  return Arrow;
	}(_react.PureComponent);
	
	Arrow.propTypes = {
	  length: _react2.default.PropTypes.number,
	  angle: _react2.default.PropTypes.number
	};
	exports.default = Arrow;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Button.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$PureComponent) {
	  _inherits(Button, _React$PureComponent);
	
	  function Button() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Button);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      if (_this.props.href && _this.props.href.startsWith('http')) return;
	
	      e.preventDefault();
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Button, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          secondary = _props.secondary,
	          size = _props.size,
	          onClick = _props.onClick,
	          others = _objectWithoutProperties(_props, ['style', 'secondary', 'size', 'onClick']);
	
	      if (secondary) {
	        if (!size) {
	          size = '0.8';
	        }
	        style = _extends({
	          background: '#7986CB'
	        }, style);
	      } else {
	        if (!size) {
	          size = '20px';
	        }
	      }
	
	      return React.createElement('a', _extends({
	        href: '',
	        onClick: this.handleClick,
	        style: _extends({
	          display: 'inline-block',
	          textAlign: 'center',
	          background: 'rgb(93, 111, 210)',
	          padding: '0.7em',
	          fontSize: typeof size == 'string' && size.indexOf('px') > -1 ? size : size + 'em',
	          lineHeight: typeof size == 'string' && size.indexOf('px') > -1 ? size : size + 'em',
	          color: 'white',
	          textShadow: 'none'
	        }, style),
	        role: 'button'
	      }, others));
	    }
	  }]);
	
	  return Button;
	}(React.PureComponent);
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/CodeSample.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeSample code{font-size:13px;line-height:13px}", ""]);
	
	// exports


/***/ }),

/***/ "./src/components/CodeSample.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CodeSample;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__("./src/components/CodeSample.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CodeSample(props) {
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)("CodeSample", props.className),
	    dangerouslySetInnerHTML: { __html: props.code }
	  });
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/CodeSampleTabs.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__("./src/components/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CodeSample = __webpack_require__("./src/components/CodeSample.js");
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	var _keyBy = __webpack_require__("./node_modules/lodash/keyBy.js");
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CodeSampleTabs = function (_React$PureComponent) {
	  _inherits(CodeSampleTabs, _React$PureComponent);
	
	  function CodeSampleTabs(props) {
	    _classCallCheck(this, CodeSampleTabs);
	
	    var _this = _possibleConstructorReturn(this, (CodeSampleTabs.__proto__ || Object.getPrototypeOf(CodeSampleTabs)).call(this));
	
	    _this.byIndex = (0, _keyBy2.default)(props.tabs, 'id');
	    _this.state = {
	      current: props.initial
	    };
	    return _this;
	  }
	
	  _createClass(CodeSampleTabs, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _byIndex$state$curren = this.byIndex[this.state.current],
	          code = _byIndex$state$curren.code,
	          label = _byIndex$state$curren.label,
	          id = _byIndex$state$curren.id;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "IndexPage-TabControl" },
	        _react2.default.createElement(
	          "div",
	          { className: "IndexPage-Tabs" },
	          this.props.tabs.map(function (tab) {
	            return _react2.default.createElement(
	              _Button2.default,
	              { key: tab.id, size: '12px', href: "", onClick: function onClick() {
	                  return _this2.setState({ current: tab.id });
	                } },
	              tab.label
	            );
	          })
	        ),
	        _react2.default.createElement(_CodeSample2.default, { code: code })
	      );
	    }
	  }]);
	
	  return CodeSampleTabs;
	}(_react2.default.PureComponent);
	
	exports.default = CodeSampleTabs;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/HeroSlide.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".IndexPage-HeroBg{background:url(" + __webpack_require__("./src/components/cubes.png") + "),#fafaff linear-gradient(139deg,#fafaff 45%,#effaff);background-size:40px,100%;border-bottom:1px solid #eaeaea}.IndexPage-Hero{font-family:futura-pt;font-weight:700;display:flex;flex-direction:column;margin-top:50px;margin-bottom:70px;text-align:center}.IndexPage-Hero img{vertical-align:text-bottom;margin-bottom:0;margin-left:7px;margin-right:-15px;height:92px}.IndexPage-Hero h1,.IndexPage-Hero h2,.IndexPage-Hero h3,.IndexPage-Hero h4{margin:0;font-family:inherit;font-weight:400;font-size:60px;letter-spacing:0}.HeroSlide--bold h1,.HeroSlide--bold h2,.HeroSlide--bold h3,.HeroSlide--bold h4{font-weight:700}.IndexPage-Hero h2{font-size:50px;line-height:60px;color:#000;margin-top:.3em}.IndexPage-Hero h4{font-size:30px;margin-top:.5em;line-height:1.3em;text-transform:none;color:#000}@media (max-height:640px){.IndexPage-Hero h2{font-size:48px}.IndexPage-Hero h4{font-size:26px}.IndexPage-Hero img{height:auto}}", ""]);
	
	// exports


/***/ }),

/***/ "./src/components/HeroSlide.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactResponsiveGrid = __webpack_require__("./node_modules/react-responsive-grid/dist/index.js");
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _Header = __webpack_require__("./src/layouts/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SignupButton = __webpack_require__("./src/components/SignupButton.js");
	
	var _SignupButton2 = _interopRequireDefault(_SignupButton);
	
	var _Button = __webpack_require__("./src/components/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _logo = __webpack_require__("./src/logo.png");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _MailchimpScripts = __webpack_require__("./src/components/MailchimpScripts.js");
	
	var _MailchimpScripts2 = _interopRequireDefault(_MailchimpScripts);
	
	__webpack_require__("./src/components/HeroSlide.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeroSlide = function (_React$Component) {
	  _inherits(HeroSlide, _React$Component);
	
	  function HeroSlide() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeroSlide);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeroSlide.__proto__ || Object.getPrototypeOf(HeroSlide)).call.apply(_ref, [this].concat(args))), _this), _this.showMailingListPopUp = function () {
	      _this.refs.mailchimp.open();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HeroSlide, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "IndexPage-HeroBg" },
	        _react2.default.createElement(
	          _reactResponsiveGrid.Container,
	          {
	            style: {
	              maxWidth: (0, _typography.rhythm)(35),
	              padding: (0, _typography.rhythm)(0.5) + " " + (0, _typography.rhythm)(3 / 4) + " " + (0, _typography.rhythm)(1)
	            }
	          },
	          _react2.default.createElement(_MailchimpScripts2.default, { ref: "mailchimp" }),
	          _react2.default.createElement(_Header2.default, {
	            showLogo: !this.props.hideLogo,
	            selectedPlatform: this.props.selectedPlatform
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: (0, _classnames2.default)('IndexPage-Hero', this.props.bold ? 'HeroSlide--bold' : false) },
	            _react2.default.createElement(
	              "h2",
	              null,
	              this.props.title
	            ),
	            _react2.default.createElement(
	              "h4",
	              null,
	              this.props.subtitle
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: {
	                marginBottom: '50px',
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center'
	              } },
	            _react2.default.createElement(_SignupButton2.default, null),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                secondary: true,
	                onClick: this.showMailingListPopUp,
	                style: { marginLeft: '20px' }
	              },
	              "Subscribe to mailinglist"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeroSlide;
	}(_react2.default.Component);
	
	HeroSlide.propTypes = {
	  hideLogo: _react.PropTypes.bool,
	  title: _react.PropTypes.any,
	  subtitle: _react.PropTypes.any
	};
	exports.default = HeroSlide;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/MailchimpScripts.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadJs = __webpack_require__("./src/utils/load-js.js");
	
	var _loadJs2 = _interopRequireDefault(_loadJs);
	
	var _ga = __webpack_require__("./src/utils/ga.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MailchimpScripts = function (_React$Component) {
	  _inherits(MailchimpScripts, _React$Component);
	
	  function MailchimpScripts() {
	    _classCallCheck(this, MailchimpScripts);
	
	    return _possibleConstructorReturn(this, (MailchimpScripts.__proto__ || Object.getPrototypeOf(MailchimpScripts)).apply(this, arguments));
	  }
	
	  _createClass(MailchimpScripts, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _loadJs2.default)({
	        url: 'https://s3.amazonaws.com/downloads.mailchimp.com/js/signup-forms/popup/embed.js',
	        createFunc: function createFunc(scriptTag) {
	          scriptTag.dataset['dojoConfig'] = 'usePlainJson: true, isDebug: false';
	        }
	      }).then(function () {
	        window.require(["mojo/signup-forms/Loader"], function (L) {
	          _this2.L = L;
	        });
	      });
	    }
	
	    // https://gist.github.com/scottmagdalein/259d878ad46ed6f2cdce
	
	  }, {
	    key: 'open',
	    value: function open() {
	      (0, _ga.gaEvent)('mailinglist', 'popup-open');
	      document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
	      this.L.start({ "baseUrl": "mc.us14.list-manage.com", "uuid": "2eb5079cc9179616cde242578", "lid": "e255b328f5" });
	      document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
	    }
	  }]);
	
	  return MailchimpScripts;
	}(_react2.default.Component);
	
	exports.default = MailchimpScripts;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/SignupAndPlansSlide.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SignupAdPlanSlide;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsiveGrid = __webpack_require__("./node_modules/react-responsive-grid/dist/index.js");
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _SignupButton = __webpack_require__("./src/components/SignupButton.js");
	
	var _SignupButton2 = _interopRequireDefault(_SignupButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SignupAdPlanSlide(props) {
	  return _react2.default.createElement(
	    "div",
	    { style: { borderTop: '1px solid silver' } },
	    _react2.default.createElement(
	      _reactResponsiveGrid.Container,
	      {
	        style: {
	          maxWidth: (0, _typography.rhythm)(35),
	          padding: (0, _typography.rhythm)(2) + " " + (0, _typography.rhythm)(3 / 4),
	          textAlign: 'center'
	        }
	      },
	      _react2.default.createElement(
	        "h3",
	        { style: { marginTop: 0 } },
	        props.prompt
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { marginTop: '50px', marginBottom: '40px' }, className: "IndexPage-ButtonBar" },
	        _react2.default.createElement(_SignupButton2.default, null),
	        _react2.default.createElement(
	          "a",
	          { href: "/pricing", style: {
	              marginLeft: '30px'
	            } },
	          "See all our plans"
	        )
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/SignupButton.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".Button-With-Helpers{position:relative}.Login-Button-Helpers{font-size:15px;color:#000;position:absolute;top:50px;left:0;right:0;text-align:center}@media (max-height:640px){.Login-Button-Helpers{display:none}}.Login-Button-Helpers svg{width:20px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),

/***/ "./src/components/SignupButton.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SignupButton;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__("./src/components/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _githubColor = __webpack_require__("./src/components/github-color.svgc");
	
	var _githubColor2 = _interopRequireDefault(_githubColor);
	
	var _googleColor = __webpack_require__("./src/components/google-color.svgc");
	
	var _googleColor2 = _interopRequireDefault(_googleColor);
	
	__webpack_require__("./src/components/SignupButton.css");
	
	var _ga = __webpack_require__("./src/utils/ga.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SignupButton(props) {
	  return _react2.default.createElement(
	    _Button2.default,
	    { onClick: _ga.gotoSignup, className: 'Button-With-Helpers' },
	    'Signup now for free',
	    _react2.default.createElement(
	      'div',
	      { className: 'Login-Button-Helpers' },
	      'Login with ',
	      _react2.default.createElement(_githubColor2.default, null),
	      ' ',
	      _react2.default.createElement(_googleColor2.default, null)
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/cubes.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABkCAMAAADqvX3PAAAAKlBMVEUAAADX19fX19fBwcHT09PX19fW1tbT09PW1tbV1dXOzs7Ozs7BwcHV1dX5uIg2AAAADnRSTlMAPQAKH0czAAApFAAAAHys1goAAAHwSURBVHja7ZfdcuMwCEb1GUIDcd//dZuk2n5rZzCKOzuzFzo3+XNOBAIHtQosxwi0XUw/jjh2qN1pVzV43FJwJIDLuq5tvaNmzxeEZI5wWP/p9v0gypgGYhGH8fL28yyM7ycOJkFlJW3tZDHhRdBjIO22JR6a1BGMgTAWopvr6BC1jSB1MDWyXYfvkpDlg4iiV83lITiuoXZL+U4/ltcNq2MhogaYBWMYjYU8HHfSRdTrCIOLYImemrfz8dMO6DlVGYyFMWz3tmuGY6GgO1ikXVM51JDXurBO0nyEcyPTnvOXvmyb0hzqfV64jUUYw47Re9CZe6EbeC+M39+TcfK/gTFZuxZgOSag7aMASwGkrQW1Y2lLwXRMx3RMx3T8Pw67FpSOcA5RCccOcTMNL05aRw7Fn2kizA7+1VNH6ENAOBgOxiIK888dHPVqh+Q/yeknzQfHkhx+nqyjT0QFzDUd2Skp53lp7PdFnEkYIhzQv/KRzJUV0QdDSON5+S14CEW0vqSTiAPWWDknCLsY0BZxnNP0L/Z9YQEO8yznXZ2yNwfgTu7rNFgj9aamvS9eZljMTNOeoybSGNwQkvZ+3XrCU07t4HmWSBjDLBzEwdSzhMYcRPRZNYmgdjA1FyahcKQIqpKZs8N0TMd0TMd0/BvHF8n9f8tHo7HcAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./src/components/github-color.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function GithubColor (props) {
	    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFFFFF","cx":"24","cy":"24","r":"17","key":0}),React.createElement("g",{"key":1},[React.createElement("path",{"fill":"#455A64","d":"M21,41v-5.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5V41h2v-6.5c0-0.276,0.224-0.5,0.5-0.5\n\t\ts0.5,0.224,0.5,0.5V41h2v-5.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5V41h1.758C29.914,40.725,30,40.373,30,39.921v-3.942\n\t\tc0-2.161-1.91-5.231-4.251-5.231H23.25c-2.34,0-4.25,3.071-4.25,5.231v3.942c0,0.452,0.086,0.804,0.241,1.079H21z","key":0}),React.createElement("path",{"fill":"none","stroke":"#455A64","strokeWidth":"0.25","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM34.618,26.197c0,0,1.914-0.328,3.044-0.308c1.143,0.011,2.438,0.363,2.438,0.363","key":1}),React.createElement("path",{"fill":"none","stroke":"#455A64","strokeWidth":"0.25","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM34.136,26.814c0,0,2.186-0.203,3.087-0.175c1.252,0.032,2.592,0.417,2.592,0.417","key":2}),React.createElement("path",{"fill":"none","stroke":"#455A64","strokeWidth":"0.25","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM14.564,26.089c0,0-2.708-0.245-3.554-0.245c-0.848,0-2.452,0.245-3.224,0.466","key":3}),React.createElement("path",{"fill":"none","stroke":"#455A64","strokeWidth":"0.25","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.179,26.934c0,0-2.839-0.263-4.131-0.108c-1.545,0.183-2.894,0.992-2.894,0.992","key":4}),React.createElement("path",{"fill":"#455A64","d":"M14.174,23.46c0-4.416,4.619-8.46,10.326-8.46c5.697,0,10.326,4.042,10.326,8.46\n\t\tc0,4.419-3.313,7.54-10.326,7.54C17.488,31,14.174,27.879,14.174,23.46z","key":5}),React.createElement("path",{"fill":"#455A64","d":"M28.586,16.311c0,0,1.677-2.312,4.77-2.312c1.232,1.231,0.385,4.76-0.018,5.819L28.586,16.311z","key":6}),React.createElement("path",{"fill":"#455A64","d":"M20.403,16.312c0,0-1.677-2.312-4.758-2.312c-1.231,1.233-0.396,4.76,0.006,5.819L20.403,16.312z","key":7}),React.createElement("path",{"fill":"#455A64","d":"M20.106,35.863c0,0-2.349,0-2.79,0c-1.22,0-2.3-0.534-2.823-1.505c-0.587-1.079-1.14-2.3-2.585-3.309\n\t\tc-0.255-0.179-0.108-0.438,0.393-0.38c0.489,0.051,1.416,0.159,2.126,1.088c0.708,0.93,1.481,1.997,2.81,1.997\n\t\tc1.316,0,2.747,0.035,3.468-0.918L20.106,35.863z","key":8})]),React.createElement("path",{"fill":"#00BCD4","d":"M24,5C13.504,5,5,13.504,5,24s8.504,19,19,19s19-8.504,19-19S34.496,5,24,5z M24,40.033\n\tc-8.838,0-16.033-7.195-16.033-16.033S15.162,7.967,24,7.967S40.033,15.162,40.033,24S32.838,40.033,24,40.033z","key":2})]);
	}
	
	GithubColor.displayName = "GithubColor";
	
	GithubColor.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"48","height":"48","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = GithubColor;
	
	GithubColor.default = GithubColor;


/***/ }),

/***/ "./src/components/google-color.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function GoogleColor (props) {
	    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFC107","d":"M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12\n\tc0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24\n\tc0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z","key":0}),React.createElement("path",{"fill":"#FF3D00","d":"M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657\n\tC34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z","key":1}),React.createElement("path",{"fill":"#4CAF50","d":"M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36\n\tc-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z","key":2}),React.createElement("path",{"fill":"#1976D2","d":"M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571\n\tc0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z","key":3})]);
	}
	
	GoogleColor.displayName = "GoogleColor";
	
	GoogleColor.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"48","height":"48","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = GoogleColor;
	
	GoogleColor.default = GoogleColor;


/***/ }),

/***/ "./src/layouts/Footer.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "html{position:relative;min-height:100%}body{margin-bottom:100px}footer{border-top:1px solid #eaeaea;min-height:100px;position:absolute;bottom:0;width:100%;background:#f5f5f5;display:flex;flex-direction:row;align-items:center;justify-content:center}footer ul{list-style-type:none;margin:0}footer ul li{display:inline-block;margin:0 20px}", ""]);
	
	// exports


/***/ }),

/***/ "./src/layouts/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsiveGrid = __webpack_require__("./node_modules/react-responsive-grid/dist/index.js");
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__("./src/layouts/Footer.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: "render",
	    value: function render() {
	      var showLogo = this.props.showLogo;
	
	
	      return _react2.default.createElement(
	        "footer",
	        { style: { background: '#FBFBFB' } },
	        _react2.default.createElement(
	          _reactResponsiveGrid.Container,
	          {
	            style: {
	              maxWidth: (0, _typography.rhythm)(35),
	              padding: (0, _typography.rhythm)(0.5) + " " + (0, _typography.rhythm)(3 / 4)
	            }
	          },
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              "\xA9 2017-2022 Project Maple Ltd"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/docs' },
	                "Documentation"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact' },
	                "Contact Us & Support"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/privacy' },
	                "Privacy"
	              )
	            )
	          ),
	          this.props.children && _react2.default.createElement(
	            "div",
	            { style: { marginLeft: '20px' } },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react2.default.Component);
	
	Footer.propTypes = {};
	
	Footer.defaultProps = {};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/layouts/Header.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".Header{display:flex;align-items:center;min-height:50px}.Header-Logo{text-decoration:none;box-shadow:none;background-image:none;flex-shrink:0}.Header-Logo img{height:50px;margin:0;vertical-align:middle}.Header ul{flex:1;margin:0;text-align:right;list-style-type:none}.Header ul li{display:inline;margin:5px 15px}@media (max-height:640px){.Header{flex-wrap:wrap}.Header ul{text-align:left}.Header ul li{margin-left:0}.Header ul li [role=button]{display:none!important}}.Popper{position:absolute;color:#000;width:150px;border-radius:3px;box-shadow:0 0 2px rgba(0,0,0,.5);padding:10px;text-align:center}.Popper .Popper-arrow{width:0;height:0;border-style:solid;position:absolute;margin:5px}.Popper[data-placement^=top]{margin-bottom:5px}.Popper[data-placement^=top] .Popper-arrow{border-width:5px 5px 0;border-left-color:transparent;border-right-color:transparent;border-bottom-color:transparent;bottom:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0}.Popper[data-placement^=bottom]{margin-top:5px}.Popper[data-placement^=bottom] .Popper-arrow{border-width:0 5px 5px;border-left-color:transparent;border-right-color:transparent;border-top-color:transparent;top:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0}.Popper[data-placement^=right] .Popper-arrow{border-width:5px 5px 5px 0;border-left-color:transparent;border-top-color:transparent;border-bottom-color:transparent;left:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0}.Popper[data-placement^=left]{margin-right:5px}.Popper[data-placement^=left] .Popper-arrow{border-width:5px 0 5px 5px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;right:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0}.TechSelector-Link--platform{text-decoration:none;background-image:none;text-shadow:none;border:none;color:#1f1d1d!important}.TechSelector-Link{position:relative;padding-right:16px}.TechSelector-Link:after{border:5px solid transparent;border-top-color:#3f51b5;border-top-width:7px;content:\" \";display:inline-block;position:absolute;vertical-align:bottom;top:50%;margin-top:-4px;right:0}.TechSelector-Link svg{fill:#1f1d1d!important;width:30px;height:30px;margin-right:0;vertical-align:middle}.TechSelector-Popup{background-color:#1f1d1d;color:#fff;text-align:left;padding:0}.TechSelector-Popup .Popper-arrow{border-color:#1f1d1d}.TechSelector-Popup a{display:block;border-bottom:1px solid silver;padding:10px;text-decoration:none;background:none;text-shadow:none;color:#fff;vertical-align:middle}.TechSelector-Popup a:hover{background:#fff;color:#000}.TechSelector-Popup a:hover svg{fill:#000!important}.TechSelector-Popup svg{height:30px;width:30px;margin-right:5px;vertical-align:middle}", ""]);
	
	// exports


/***/ }),

/***/ "./src/layouts/Header.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyBy = __webpack_require__("./node_modules/lodash/keyBy.js");
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _reactPopper = __webpack_require__("./node_modules/react-popper/lib/react-popper.js");
	
	var _logo = __webpack_require__("./src/logo.png");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__("./src/layouts/Header.css");
	
	var _ga = __webpack_require__("./src/utils/ga.js");
	
	var _Button = __webpack_require__("./src/components/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _android = __webpack_require__("./src/layouts/android.svgc");
	
	var _android2 = _interopRequireDefault(_android);
	
	var _js = __webpack_require__("./src/layouts/js.svgc");
	
	var _js2 = _interopRequireDefault(_js);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showLogo = _props.showLogo,
	          selectedPlatform = _props.selectedPlatform;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Header' },
	        showLogo && _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/index', className: 'Header-Logo' },
	          _react2.default.createElement('img', { src: _logo2.default })
	        ),
	        _react2.default.createElement(Selector, {
	          style: { marginLeft: '10px' },
	          selectedPlatform: selectedPlatform
	        }),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/docs' },
	              'Documentation'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/pricing' },
	              'Pricing'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: "https://app.bundlecop.com" },
	              'Login'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: _ga.gotoSignup },
	              'Signup'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	  showLogo: _react2.default.PropTypes.bool
	};
	
	Header.defaultProps = {
	  showLogo: true
	};
	
	exports.default = Header;
	
	// TODO: react-pverlays didn't postion correctly, but once they
	// start using popper it might be nice because it gives us an animation
	// for free.
	
	var Selector = function (_React$Component2) {
	  _inherits(Selector, _React$Component2);
	
	  function Selector() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, Selector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Selector.__proto__ || Object.getPrototypeOf(Selector)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	      isOpen: false
	    }, _this2.handleClick = function (e) {
	      e.preventDefault();
	      _this2.setState({ isOpen: !_this2.state.isOpen });
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(Selector, [{
	    key: 'render',
	    value: function render() {
	      var platforms = [{
	        id: 'android',
	        icon: _android2.default,
	        label: 'Android'
	      }, {
	        id: 'js',
	        url: '/',
	        icon: _js2.default,
	        label: 'JavaScript'
	      }];
	
	      var byId = (0, _keyBy2.default)(platforms, 'id');
	
	      var CurrentIcon = void 0;
	      var platform = byId[this.props.selectedPlatform];
	      if (platform) {
	        CurrentIcon = platform.icon;
	      }
	
	      return _react2.default.createElement(
	        _reactPopper.Manager,
	        { className: 'TechSelector' },
	        _react2.default.createElement(
	          _reactPopper.Target,
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: '',
	              onClick: this.handleClick,
	              style: this.props.style,
	              className: (0, _classnames2.default)("TechSelector-Link", platform && "TechSelector-Link--platform")
	            },
	            !platform ? "Platforms" : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(CurrentIcon, null),
	              ' ',
	              platform.label
	            )
	          )
	        ),
	        this.state.isOpen && _react2.default.createElement(
	          _reactPopper.Popper,
	          { placement: 'bottom', className: 'Popper TechSelector-Popup' },
	          platforms.map(function (_ref2) {
	            var Icon = _ref2.icon,
	                label = _ref2.label,
	                url = _ref2.url,
	                id = _ref2.id;
	
	            return _react2.default.createElement(
	              _gatsbyLink2.default,
	              { key: id, to: url || '/' + id },
	              _react2.default.createElement(Icon, null),
	              ' ',
	              label
	            );
	          }),
	          _react2.default.createElement(_reactPopper.Arrow, { className: 'Popper-arrow' })
	        )
	      );
	    }
	  }]);
	
	  return Selector;
	}(_react2.default.Component);
	
	Selector.propTypes = {
	  selectedPlatform: _react2.default.PropTypes.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./src/layouts/android.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Android (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},React.createElement("path",{"style":{},"d":"M 28.015625 5.988281 C 27.664063 5.980469 27.332031 6.160156 27.144531 6.457031 C 26.957031 6.757813 26.945313 7.132813 27.105469 7.445313 L 29.78125 12.796875 C 28.640625 13.449219 27.578125 14.183594 26.625 14.984375 C 23.207031 17.875 21 21.550781 21 25 L 21 27.109375 C 20.15625 26.457031 19.144531 26 18 26 C 15.25 26 13 28.25 13 31 L 13 49 C 13 51.75 15.25 54 18 54 C 19.144531 54 20.15625 53.542969 21 52.890625 L 21 57 C 21 58.644531 22.355469 60 24 60 L 27 60 L 27 69 C 27 71.75 29.25 74 32 74 C 34.75 74 37 71.75 37 69 L 37 60 L 43 60 L 43 69 C 43 71.75 45.25 74 48 74 C 50.75 74 53 71.75 53 69 L 53 60 L 56 60 C 57.644531 60 59 58.644531 59 57 L 59 52.890625 C 59.84375 53.542969 60.855469 54 62 54 C 64.75 54 67 51.75 67 49 L 67 31 C 67 28.25 64.75 26 62 26 C 60.855469 26 59.84375 26.457031 59 27.109375 L 59 25 C 59 21.550781 56.792969 17.875 53.375 14.984375 C 52.421875 14.183594 51.359375 13.449219 50.21875 12.796875 L 52.894531 7.445313 C 53.058594 7.128906 53.042969 6.746094 52.847656 6.445313 C 52.652344 6.144531 52.3125 5.96875 51.953125 5.988281 C 51.589844 6.007813 51.265625 6.222656 51.105469 6.554688 L 48.4375 11.882813 C 45.902344 10.722656 43.042969 10 40 10 C 36.957031 10 34.097656 10.722656 31.5625 11.882813 L 28.894531 6.554688 C 28.730469 6.214844 28.390625 5.996094 28.015625 5.988281 Z M 40 12 C 44.703125 12 48.988281 13.902344 52.082031 16.515625 C 55.175781 19.125 57 22.449219 57 25 L 57 31 L 59 31 C 59 29.332031 60.332031 28 62 28 C 63.667969 28 65 29.332031 65 31 L 65 49 C 65 50.667969 63.667969 52 62 52 C 60.332031 52 59 50.667969 59 49 L 57 49 L 57 57 C 57 57.566406 56.566406 58 56 58 L 51 58 L 51 69 C 51 70.667969 49.667969 72 48 72 C 46.332031 72 45 70.667969 45 69 L 45 58 L 35 58 L 35 69 C 35 70.667969 33.667969 72 32 72 C 30.332031 72 29 70.667969 29 69 L 29 58 L 24 58 C 23.433594 58 23 57.566406 23 57 L 23 49 L 21 49 C 21 50.667969 19.667969 52 18 52 C 16.332031 52 15 50.667969 15 49 L 15 31 C 15 29.332031 16.332031 28 18 28 C 19.667969 28 21 29.332031 21 31 L 23 31 L 23 25 C 23 22.449219 24.824219 19.125 27.917969 16.515625 C 31.011719 13.902344 35.296875 12 40 12 Z M 32.996094 17 C 31.894531 17 31 17.890625 31 18.996094 C 31 20.105469 31.894531 21 32.996094 21 C 34.105469 21 35 20.105469 35 18.996094 C 35 17.890625 34.105469 17 32.996094 17 Z M 46.996094 17 C 45.894531 17 45 17.890625 45 18.996094 C 45 20.105469 45.894531 21 46.996094 21 C 48.105469 21 49 20.105469 49 18.996094 C 49 17.890625 48.105469 17 46.996094 17 Z M 26 24 C 25.449219 24 25 24.449219 25 25 C 25 25.550781 25.449219 26 26 26 C 26.550781 26 27 25.550781 27 25 C 27 24.449219 26.550781 24 26 24 Z M 30 24 C 29.449219 24 29 24.449219 29 25 C 29 25.550781 29.449219 26 30 26 C 30.550781 26 31 25.550781 31 25 C 31 24.449219 30.550781 24 30 24 Z M 34 24 C 33.449219 24 33 24.449219 33 25 C 33 25.550781 33.449219 26 34 26 C 34.550781 26 35 25.550781 35 25 C 35 24.449219 34.550781 24 34 24 Z M 38 24 C 37.449219 24 37 24.449219 37 25 C 37 25.550781 37.449219 26 38 26 C 38.550781 26 39 25.550781 39 25 C 39 24.449219 38.550781 24 38 24 Z M 42 24 C 41.449219 24 41 24.449219 41 25 C 41 25.550781 41.449219 26 42 26 C 42.550781 26 43 25.550781 43 25 C 43 24.449219 42.550781 24 42 24 Z M 46 24 C 45.449219 24 45 24.449219 45 25 C 45 25.550781 45.449219 26 46 26 C 46.550781 26 47 25.550781 47 25 C 47 24.449219 46.550781 24 46 24 Z M 50 24 C 49.449219 24 49 24.449219 49 25 C 49 25.550781 49.449219 26 50 26 C 50.550781 26 51 25.550781 51 25 C 51 24.449219 50.550781 24 50 24 Z M 54 24 C 53.449219 24 53 24.449219 53 25 C 53 25.550781 53.449219 26 54 26 C 54.550781 26 55 25.550781 55 25 C 55 24.449219 54.550781 24 54 24 Z M 22 33 C 21.449219 33 21 33.449219 21 34 C 21 34.550781 21.449219 35 22 35 C 22.550781 35 23 34.550781 23 34 C 23 33.449219 22.550781 33 22 33 Z M 58 33 C 57.449219 33 57 33.449219 57 34 C 57 34.550781 57.449219 35 58 35 C 58.550781 35 59 34.550781 59 34 C 59 33.449219 58.550781 33 58 33 Z M 22 37 C 21.449219 37 21 37.449219 21 38 C 21 38.550781 21.449219 39 22 39 C 22.550781 39 23 38.550781 23 38 C 23 37.449219 22.550781 37 22 37 Z M 58 37 C 57.449219 37 57 37.449219 57 38 C 57 38.550781 57.449219 39 58 39 C 58.550781 39 59 38.550781 59 38 C 59 37.449219 58.550781 37 58 37 Z M 22 41 C 21.449219 41 21 41.449219 21 42 C 21 42.550781 21.449219 43 22 43 C 22.550781 43 23 42.550781 23 42 C 23 41.449219 22.550781 41 22 41 Z M 58 41 C 57.449219 41 57 41.449219 57 42 C 57 42.550781 57.449219 43 58 43 C 58.550781 43 59 42.550781 59 42 C 59 41.449219 58.550781 41 58 41 Z M 22 45 C 21.449219 45 21 45.449219 21 46 C 21 46.550781 21.449219 47 22 47 C 22.550781 47 23 46.550781 23 46 C 23 45.449219 22.550781 45 22 45 Z M 58 45 C 57.449219 45 57 45.449219 57 46 C 57 46.550781 57.449219 47 58 47 C 58.550781 47 59 46.550781 59 46 C 59 45.449219 58.550781 45 58 45 Z M 32 58 C 31.449219 58 31 58.449219 31 59 C 31 59.550781 31.449219 60 32 60 C 32.550781 60 33 59.550781 33 59 C 33 58.449219 32.550781 58 32 58 Z M 48 58 C 47.449219 58 47 58.449219 47 59 C 47 59.550781 47.449219 60 48 60 C 48.550781 60 49 59.550781 49 59 C 49 58.449219 48.550781 58 48 58 Z "})));
	}
	
	Android.displayName = "Android";
	
	Android.defaultProps = {"viewBox":"0 0 80 80","version":"1.1","width":"50","height":"50","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Android;
	
	Android.default = Android;


/***/ }),

/***/ "./src/layouts/js.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Js (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},React.createElement("path",{"style":{},"d":"M 6.667969 4 C 5.207031 4 4 5.207031 4 6.667969 L 4 43.332031 C 4 44.792969 5.207031 46 6.667969 46 L 43.332031 46 C 44.792969 46 46 44.796875 46 43.332031 L 46 6.667969 C 46 5.207031 44.796875 4 43.332031 4 Z M 6.667969 6 L 43.332031 6 C 43.703125 6 44 6.296875 44 6.667969 L 44 43.332031 C 44 43.703125 43.703125 44 43.332031 44 L 6.667969 44 C 6.296875 44 6 43.703125 6 43.332031 L 6 6.667969 C 6 6.296875 6.296875 6 6.667969 6 Z M 23 23 L 23 35.574219 C 23 37.503906 22.269531 38 21 38 C 19.671875 38 18.75 37.171875 18.140625 36.097656 L 15 38 C 15.910156 39.925781 18.140625 42 21.234375 42 C 24.65625 42 27 40.179688 27 36.183594 L 27 23 Z M 35.453125 23 C 32.046875 23 29.863281 25.179688 29.863281 28.042969 C 29.863281 31.148438 31.695313 32.617188 34.449219 33.789063 L 35.402344 34.199219 C 37.140625 34.960938 38 35.425781 38 36.734375 C 38 37.824219 37.171875 38.613281 35.589844 38.613281 C 33.707031 38.613281 32.816406 37.335938 32 36 L 29 38 C 30.121094 40.214844 32.132813 42 35.675781 42 C 39.300781 42 42 40.117188 42 36.683594 C 42 33.496094 40.171875 32.078125 36.925781 30.6875 L 35.972656 30.28125 C 34.335938 29.570313 33.625 29.109375 33.625 27.964844 C 33.625 27.039063 34.335938 26.328125 35.453125 26.328125 C 36.550781 26.328125 37.253906 26.792969 37.90625 27.964844 L 40.878906 26.058594 C 39.625 23.84375 37.878906 23 35.453125 23 Z "})));
	}
	
	Js.displayName = "Js";
	
	Js.defaultProps = {"viewBox":"0 0 50 50","version":"1.1","width":"50","height":"50","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Js;
	
	Js.default = Js;


/***/ }),

/***/ "./src/logo.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/repo/website/node_modules/babel-preset-react/lib/index.js\",\"/repo/website/node_modules/babel-preset-es2015/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-1/lib/index.js\",\"/repo/website/node_modules/babel-preset-env/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/repo/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/repo/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/repo/website/node_modules/babel-preset-react/lib/index.js\",\"/repo/website/node_modules/babel-preset-es2015/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-1/lib/index.js\",\"/repo/website/node_modules/babel-preset-env/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/repo/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/repo/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index/index.js");
	
	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _index2.default;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/pages/index/Feature.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".Feature{width:300px;font-size:17px;margin:20px;line-height:1.4em}.Feature strong{font-size:21px;font-weight:700}.Feature-Icon{fill:#1b1c1d!important;width:30px;height:30px;vertical-align:bottom;margin-right:5px}.Feature-ComingSoon{background:#009688;display:inline-block;padding:.01em .4em;border-radius:4px;color:#fff;font-size:.7em;vertical-align:bottom;margin:0 .4em 0 0}", ""]);
	
	// exports


/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/repo/website/node_modules/babel-preset-react/lib/index.js\",\"/repo/website/node_modules/babel-preset-es2015/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-1/lib/index.js\",\"/repo/website/node_modules/babel-preset-env/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/repo/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/repo/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index/Feature.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__("./src/pages/index/Feature.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feature = function (_React$Component) {
	  _inherits(Feature, _React$Component);
	
	  function Feature() {
	    _classCallCheck(this, Feature);
	
	    return _possibleConstructorReturn(this, (Feature.__proto__ || Object.getPrototypeOf(Feature)).apply(this, arguments));
	  }
	
	  _createClass(Feature, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          Icon = _props.Icon,
	          comingSoon = _props.comingSoon;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "Feature" },
	        Icon && _react2.default.createElement(Icon, { className: "Feature-Icon" }),
	        comingSoon && _react2.default.createElement(
	          "div",
	          { className: "Feature-ComingSoon" },
	          "Coming Soon"
	        ),
	        children
	      );
	    }
	  }]);
	
	  return Feature;
	}(_react2.default.Component);
	
	Feature.propTypes = {
	  comingSoon: _react2.default.PropTypes.bool,
	  Icon: _react2.default.PropTypes.any
	};
	
	exports.default = Feature;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/pages/index/console.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/console.833eb590.png";

/***/ }),

/***/ "./src/pages/index/dashboard.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dashboard.c9cffd8c.png";

/***/ }),

/***/ "./src/pages/index/gears.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Gears (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M 19.523438 4 L 17.630859 8.7304688 C 15.431713 9.4030146 13.455382 10.54957 11.8125 12.080078 L 6.7851562 11.355469 L 4.3066406 15.646484 L 7.4550781 19.648438 C 7.2026743 20.727553 7 21.832709 7 23 C 7 24.167386 7.2026781 25.273816 7.4550781 26.353516 L 4.3066406 30.355469 L 6.7851562 34.644531 L 11.814453 33.921875 C 13.456947 35.451489 15.432593 36.597238 17.630859 37.269531 L 19.523438 42 L 24.476562 42 L 26.369141 37.269531 C 28.568287 36.596985 30.544618 35.45043 32.1875 33.919922 L 37.214844 34.644531 L 39.693359 30.353516 L 36.544922 26.351562 C 36.797326 25.272447 37 24.167291 37 23 C 37 21.832614 36.797322 20.726184 36.544922 19.646484 L 39.693359 15.644531 L 37.214844 11.355469 L 32.185547 12.078125 C 30.543053 10.548511 28.567407 9.4027625 26.369141 8.7304688 L 24.476562 4 L 19.523438 4 z M 20.876953 6 L 23.123047 6 L 24.851562 10.320312 L 25.335938 10.449219 C 27.596723 11.048811 29.617703 12.226543 31.214844 13.832031 L 31.568359 14.1875 L 36.160156 13.527344 L 37.283203 15.472656 L 34.40625 19.128906 L 34.537109 19.613281 C 34.830831 20.702108 35 21.832519 35 23 C 35 24.167481 34.83076 25.297136 34.537109 26.384766 L 34.40625 26.869141 L 37.283203 30.525391 L 36.160156 32.472656 L 31.568359 31.810547 L 31.214844 32.166016 C 29.617703 33.771504 27.596723 34.951189 25.335938 35.550781 L 24.851562 35.679688 L 23.123047 40 L 20.876953 40 L 19.148438 35.679688 L 18.664062 35.550781 C 16.403277 34.951189 14.382297 33.773457 12.785156 32.167969 L 12.431641 31.8125 L 7.8398438 32.472656 L 6.7167969 30.527344 L 9.59375 26.871094 L 9.4628906 26.386719 C 9.1691693 25.297892 9 24.167481 9 23 C 9 21.832519 9.16924 20.702864 9.4628906 19.615234 L 9.59375 19.130859 L 6.7167969 15.474609 L 7.8398438 13.527344 L 12.431641 14.189453 L 12.785156 13.833984 C 14.382297 12.228496 16.403277 11.048811 18.664062 10.449219 L 19.148438 10.320312 L 20.876953 6 z M 56.523438 11 L 54.630859 15.730469 C 52.431713 16.403015 50.455382 17.54957 48.8125 19.080078 L 43.785156 18.355469 L 41.306641 22.646484 L 44.455078 26.648438 C 44.202674 27.727553 44 28.832709 44 30 C 44 31.167386 44.202678 32.273816 44.455078 33.353516 L 41.306641 37.355469 L 43.785156 41.644531 L 48.814453 40.921875 C 50.456947 42.451489 52.432593 43.597238 54.630859 44.269531 L 56.523438 49 L 61.476562 49 L 63.369141 44.269531 C 65.568287 43.596985 67.544618 42.45043 69.1875 40.919922 L 74.214844 41.644531 L 76.693359 37.353516 L 73.544922 33.351562 C 73.797326 32.272447 74 31.167291 74 30 C 74 28.832614 73.797322 27.726184 73.544922 26.646484 L 76.693359 22.644531 L 74.214844 18.355469 L 69.185547 19.078125 C 67.543053 17.548511 65.567407 16.402762 63.369141 15.730469 L 61.476562 11 L 56.523438 11 z M 22 12 A 1 1 0 0 0 21 13 A 1 1 0 0 0 22 14 A 1 1 0 0 0 23 13 A 1 1 0 0 0 22 12 z M 57.876953 13 L 60.123047 13 L 61.851562 17.320312 L 62.335938 17.449219 C 64.596722 18.048811 66.617703 19.226543 68.214844 20.832031 L 68.568359 21.1875 L 73.160156 20.527344 L 74.283203 22.472656 L 71.40625 26.128906 L 71.537109 26.613281 C 71.830831 27.702108 72 28.832519 72 30 C 72 31.167481 71.83076 32.297136 71.537109 33.384766 L 71.40625 33.869141 L 74.283203 37.525391 L 73.160156 39.472656 L 68.568359 38.810547 L 68.214844 39.166016 C 66.617703 40.771504 64.596722 41.951189 62.335938 42.550781 L 61.851562 42.679688 L 60.123047 47 L 57.876953 47 L 56.148438 42.679688 L 55.664062 42.550781 C 53.403276 41.951189 51.382297 40.773457 49.785156 39.167969 L 49.431641 38.8125 L 44.839844 39.472656 L 43.716797 37.527344 L 46.59375 33.871094 L 46.462891 33.386719 C 46.169169 32.297892 46 31.167481 46 30 C 46 28.832519 46.16924 27.702864 46.462891 26.615234 L 46.59375 26.130859 L 43.716797 22.474609 L 44.839844 20.527344 L 49.431641 21.189453 L 49.785156 20.833984 C 51.382297 19.228496 53.403276 18.048811 55.664062 17.449219 L 56.148438 17.320312 L 57.876953 13 z M 16.976562 13.339844 A 1 1 0 0 0 16.5 13.474609 A 1 1 0 0 0 16.134766 14.839844 A 1 1 0 0 0 17.5 15.205078 A 1 1 0 0 0 17.865234 13.839844 A 1 1 0 0 0 16.976562 13.339844 z M 26.953125 13.341797 A 1 1 0 0 0 26.134766 13.839844 A 1 1 0 0 0 26.5 15.205078 A 1 1 0 0 0 27.865234 14.839844 A 1 1 0 0 0 27.5 13.474609 A 1 1 0 0 0 26.953125 13.341797 z M 22 17 C 18.698136 17 16 19.698136 16 23 C 16 26.301864 18.698136 29 22 29 C 25.301864 29 28 26.301864 28 23 C 28 19.698136 25.301864 17 22 17 z M 30.636719 17 A 1 1 0 0 0 30.160156 17.134766 A 1 1 0 0 0 29.792969 18.5 A 1 1 0 0 0 31.160156 18.865234 A 1 1 0 0 0 31.525391 17.5 A 1 1 0 0 0 30.636719 17 z M 13.292969 17.001953 A 1 1 0 0 0 12.474609 17.5 A 1 1 0 0 0 12.839844 18.865234 A 1 1 0 0 0 14.205078 18.5 A 1 1 0 0 0 13.839844 17.134766 A 1 1 0 0 0 13.292969 17.001953 z M 22 19 C 24.220984 19 26 20.779016 26 23 C 26 25.220984 24.220984 27 22 27 C 19.779016 27 18 25.220984 18 23 C 18 20.779016 19.779016 19 22 19 z M 59 19 A 1 1 0 0 0 58 20 A 1 1 0 0 0 59 21 A 1 1 0 0 0 60 20 A 1 1 0 0 0 59 19 z M 53.974609 20.339844 A 1 1 0 0 0 53.498047 20.472656 A 1 1 0 0 0 53.132812 21.839844 A 1 1 0 0 0 54.498047 22.205078 A 1 1 0 0 0 54.865234 20.839844 A 1 1 0 0 0 53.974609 20.339844 z M 63.953125 20.341797 A 1 1 0 0 0 63.132812 20.841797 A 1 1 0 0 0 63.5 22.207031 A 1 1 0 0 0 64.865234 21.841797 A 1 1 0 0 0 64.5 20.474609 A 1 1 0 0 0 63.953125 20.341797 z M 12 22 A 1 1 0 0 0 11 23 A 1 1 0 0 0 12 24 A 1 1 0 0 0 13 23 A 1 1 0 0 0 12 22 z M 32 22 A 1 1 0 0 0 31 23 A 1 1 0 0 0 32 24 A 1 1 0 0 0 33 23 A 1 1 0 0 0 32 22 z M 59 24 C 55.698136 24 53 26.698136 53 30 C 53 33.301864 55.698136 36 59 36 C 62.301864 36 65 33.301864 65 30 C 65 26.698136 62.301864 24 59 24 z M 67.634766 24 A 1 1 0 0 0 67.158203 24.132812 A 1 1 0 0 0 66.792969 25.5 A 1 1 0 0 0 68.158203 25.865234 A 1 1 0 0 0 68.523438 24.5 A 1 1 0 0 0 67.634766 24 z M 50.291016 24.001953 A 1 1 0 0 0 49.472656 24.5 A 1 1 0 0 0 49.839844 25.867188 A 1 1 0 0 0 51.205078 25.5 A 1 1 0 0 0 50.839844 24.134766 A 1 1 0 0 0 50.291016 24.001953 z M 59 26 C 61.220984 26 63 27.779016 63 30 C 63 32.220984 61.220984 34 59 34 C 56.779016 34 55 32.220984 55 30 C 55 27.779016 56.779016 26 59 26 z M 13.316406 27 A 1 1 0 0 0 12.839844 27.132812 A 1 1 0 0 0 12.474609 28.498047 A 1 1 0 0 0 13.839844 28.865234 A 1 1 0 0 0 14.205078 27.498047 A 1 1 0 0 0 13.316406 27 z M 30.611328 27.001953 A 1 1 0 0 0 29.792969 27.5 A 1 1 0 0 0 30.158203 28.867188 A 1 1 0 0 0 31.525391 28.5 A 1 1 0 0 0 31.158203 27.134766 A 1 1 0 0 0 30.611328 27.001953 z M 49 29 A 1 1 0 0 0 48 30 A 1 1 0 0 0 49 31 A 1 1 0 0 0 50 30 A 1 1 0 0 0 49 29 z M 69 29 A 1 1 0 0 0 68 30 A 1 1 0 0 0 69 31 A 1 1 0 0 0 70 30 A 1 1 0 0 0 69 29 z M 26.976562 30.660156 A 1 1 0 0 0 26.5 30.792969 A 1 1 0 0 0 26.132812 32.158203 A 1 1 0 0 0 27.5 32.525391 A 1 1 0 0 0 27.865234 31.158203 A 1 1 0 0 0 26.976562 30.660156 z M 16.951172 30.662109 A 1 1 0 0 0 16.132812 31.160156 A 1 1 0 0 0 16.5 32.527344 A 1 1 0 0 0 17.865234 32.160156 A 1 1 0 0 0 17.5 30.794922 A 1 1 0 0 0 16.951172 30.662109 z M 22 32 A 1 1 0 0 0 21 33 A 1 1 0 0 0 22 34 A 1 1 0 0 0 23 33 A 1 1 0 0 0 22 32 z M 50.314453 34 A 1 1 0 0 0 49.837891 34.132812 A 1 1 0 0 0 49.472656 35.498047 A 1 1 0 0 0 50.837891 35.865234 A 1 1 0 0 0 51.205078 34.498047 A 1 1 0 0 0 50.314453 34 z M 67.611328 34.003906 A 1 1 0 0 0 66.792969 34.501953 A 1 1 0 0 0 67.158203 35.867188 A 1 1 0 0 0 68.525391 35.501953 A 1 1 0 0 0 68.158203 34.136719 A 1 1 0 0 0 67.611328 34.003906 z M 63.974609 37.660156 A 1 1 0 0 0 63.498047 37.792969 A 1 1 0 0 0 63.132812 39.158203 A 1 1 0 0 0 64.498047 39.525391 A 1 1 0 0 0 64.863281 38.158203 A 1 1 0 0 0 63.974609 37.660156 z M 53.951172 37.662109 A 1 1 0 0 0 53.132812 38.160156 A 1 1 0 0 0 53.498047 39.527344 A 1 1 0 0 0 54.865234 39.160156 A 1 1 0 0 0 54.498047 37.794922 A 1 1 0 0 0 53.951172 37.662109 z M 31.523438 39 L 29.630859 43.730469 C 27.431713 44.403015 25.455382 45.54957 23.8125 47.080078 L 18.785156 46.355469 L 16.306641 50.646484 L 19.455078 54.648438 C 19.202674 55.727553 19 56.832709 19 58 C 19 59.167386 19.202678 60.273816 19.455078 61.353516 L 16.306641 65.355469 L 18.785156 69.644531 L 23.814453 68.921875 C 25.456947 70.451489 27.432593 71.597238 29.630859 72.269531 L 31.523438 77 L 36.476562 77 L 38.369141 72.269531 C 40.568287 71.596985 42.544618 70.45043 44.1875 68.919922 L 49.214844 69.644531 L 51.693359 65.353516 L 48.544922 61.351562 C 48.797326 60.272447 49 59.167291 49 58 C 49 56.832614 48.797322 55.726184 48.544922 54.646484 L 51.693359 50.644531 L 49.214844 46.355469 L 44.185547 47.078125 C 42.543053 45.548511 40.567407 44.402762 38.369141 43.730469 L 36.476562 39 L 31.523438 39 z M 59 39 A 1 1 0 0 0 58 40 A 1 1 0 0 0 59 41 A 1 1 0 0 0 60 40 A 1 1 0 0 0 59 39 z M 32.876953 41 L 35.123047 41 L 36.851562 45.320312 L 37.335938 45.449219 C 39.596724 46.048811 41.617703 47.226543 43.214844 48.832031 L 43.568359 49.1875 L 48.160156 48.527344 L 49.283203 50.472656 L 46.40625 54.128906 L 46.537109 54.613281 C 46.830831 55.702108 47 56.832519 47 58 C 47 59.167481 46.83076 60.297136 46.537109 61.384766 L 46.40625 61.869141 L 49.283203 65.525391 L 48.160156 67.472656 L 43.568359 66.810547 L 43.214844 67.166016 C 41.617703 68.771504 39.596724 69.951189 37.335938 70.550781 L 36.851562 70.679688 L 35.123047 75 L 32.876953 75 L 31.148438 70.679688 L 30.664062 70.550781 C 28.403277 69.951189 26.382297 68.773457 24.785156 67.167969 L 24.431641 66.8125 L 19.839844 67.472656 L 18.716797 65.527344 L 21.59375 61.871094 L 21.462891 61.386719 C 21.169169 60.297892 21 59.167481 21 58 C 21 56.832519 21.16924 55.702864 21.462891 54.615234 L 21.59375 54.130859 L 18.716797 50.474609 L 19.839844 48.527344 L 24.431641 49.189453 L 24.785156 48.833984 C 26.382297 47.228496 28.403277 46.048811 30.664062 45.449219 L 31.148438 45.320312 L 32.876953 41 z M 34 47 A 1 1 0 0 0 33 48 A 1 1 0 0 0 34 49 A 1 1 0 0 0 35 48 A 1 1 0 0 0 34 47 z M 28.976562 48.337891 A 1 1 0 0 0 28.5 48.472656 A 1 1 0 0 0 28.132812 49.837891 A 1 1 0 0 0 29.5 50.205078 A 1 1 0 0 0 29.865234 48.837891 A 1 1 0 0 0 28.976562 48.337891 z M 38.951172 48.341797 A 1 1 0 0 0 38.132812 48.839844 A 1 1 0 0 0 38.5 50.207031 A 1 1 0 0 0 39.865234 49.839844 A 1 1 0 0 0 39.5 48.474609 A 1 1 0 0 0 38.951172 48.341797 z M 42.634766 51.998047 A 1 1 0 0 0 42.158203 52.132812 A 1 1 0 0 0 41.792969 53.498047 A 1 1 0 0 0 43.158203 53.865234 A 1 1 0 0 0 43.525391 52.498047 A 1 1 0 0 0 42.634766 51.998047 z M 34 52 C 30.698136 52 28 54.698136 28 58 C 28 61.301864 30.698136 64 34 64 C 37.301864 64 40 61.301864 40 58 C 40 54.698136 37.301864 52 34 52 z M 25.291016 52.001953 A 1 1 0 0 0 24.472656 52.501953 A 1 1 0 0 0 24.837891 53.867188 A 1 1 0 0 0 26.205078 53.501953 A 1 1 0 0 0 25.837891 52.134766 A 1 1 0 0 0 25.291016 52.001953 z M 34 54 C 36.220984 54 38 55.779016 38 58 C 38 60.220984 36.220984 62 34 62 C 31.779016 62 30 60.220984 30 58 C 30 55.779016 31.779016 54 34 54 z M 24 57 A 1 1 0 0 0 23 58 A 1 1 0 0 0 24 59 A 1 1 0 0 0 25 58 A 1 1 0 0 0 24 57 z M 44 57 A 1 1 0 0 0 43 58 A 1 1 0 0 0 44 59 A 1 1 0 0 0 45 58 A 1 1 0 0 0 44 57 z M 25.316406 61.998047 A 1 1 0 0 0 24.839844 62.132812 A 1 1 0 0 0 24.472656 63.498047 A 1 1 0 0 0 25.839844 63.863281 A 1 1 0 0 0 26.205078 62.498047 A 1 1 0 0 0 25.316406 61.998047 z M 42.611328 62.001953 A 1 1 0 0 0 41.792969 62.501953 A 1 1 0 0 0 42.158203 63.867188 A 1 1 0 0 0 43.523438 63.501953 A 1 1 0 0 0 43.158203 62.134766 A 1 1 0 0 0 42.611328 62.001953 z M 38.974609 65.658203 A 1 1 0 0 0 38.498047 65.792969 A 1 1 0 0 0 38.132812 67.158203 A 1 1 0 0 0 39.498047 67.523438 A 1 1 0 0 0 39.865234 66.158203 A 1 1 0 0 0 38.974609 65.658203 z M 28.951172 65.662109 A 1 1 0 0 0 28.132812 66.160156 A 1 1 0 0 0 28.498047 67.527344 A 1 1 0 0 0 29.865234 67.160156 A 1 1 0 0 0 29.498047 65.794922 A 1 1 0 0 0 28.951172 65.662109 z M 34 67 A 1 1 0 0 0 33 68 A 1 1 0 0 0 34 69 A 1 1 0 0 0 35 68 A 1 1 0 0 0 34 67 z"}));
	}
	
	Gears.displayName = "Gears";
	
	Gears.defaultProps = {"viewBox":"0 0 80 80","width":"80","height":"80","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Gears;
	
	Gears.default = Gears;


/***/ }),

/***/ "./src/pages/index/github.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Github (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M 31 2 C 15.01 2 2 15.01 2 31 C 2 43.648 10.142984 54.424859 21.458984 58.380859 C 21.618984 58.493859 21.807766 58.561406 22.009766 58.566406 C 24.841766 59.492406 27.862 60 31 60 C 46.99 60 60 46.99 60 31 C 60 15.01 46.99 2 31 2 z M 31 4 C 45.888 4 58 16.112 58 31 C 58 42.659 50.569266 52.614766 40.197266 56.384766 C 40.089266 56.062766 39.998047 55.581859 39.998047 55.255859 L 40 50 C 40 47.908 38.977703 45.625703 37.970703 44.095703 C 43.520703 43.156703 49.865234 40.276203 49.865234 29.533203 C 49.865234 26.585203 48.942047 23.987734 47.123047 21.802734 C 47.524047 20.487734 48.016625 17.718188 46.640625 14.242188 C 46.530625 13.964187 46.300625 13.749203 46.015625 13.658203 C 45.735625 13.569203 43.167891 12.900437 37.837891 16.398438 C 35.671891 15.838437 33.377953 15.551016 31.001953 15.541016 C 28.631953 15.552016 26.337781 15.839438 24.175781 16.398438 C 18.846781 12.898438 16.275141 13.568203 15.994141 13.658203 C 15.709141 13.749203 15.479141 13.964187 15.369141 14.242188 C 13.992141 17.721187 14.484672 20.487734 14.888672 21.802734 C 13.067672 23.989734 12.144531 26.587203 12.144531 29.533203 C 12.144531 40.180203 18.374906 43.112844 23.878906 44.089844 C 23.185906 44.965844 22.459625 46.099047 22.140625 47.248047 C 20.720625 47.644047 17.805656 47.656688 15.847656 44.304688 C 15.776656 44.175688 14.065359 41.138344 10.693359 40.902344 C 10.155359 40.905344 8.7987031 40.99125 8.4707031 42.03125 C 8.1057031 43.18525 9.3807813 44.057687 9.9257812 44.429688 C 9.9617812 44.453688 10.013734 44.484906 10.052734 44.503906 C 10.114734 44.534906 11.569297 45.299109 12.654297 48.037109 C 12.884297 48.749109 14.872813 54.135453 22.007812 53.189453 C 22.009812 53.978453 22.005953 54.375406 22.001953 54.691406 L 21.998047 55.248047 C 21.998047 55.576047 21.903016 56.060859 21.791016 56.380859 C 11.423016 52.606859 4 42.654 4 31 C 4 16.112 16.112 4 31 4 z M 30.757812 7.0039062 C 26.859922 7.0470781 23.003422 8.0741719 19.607422 10.013672 C 19.127422 10.286672 18.960375 10.897953 19.234375 11.376953 C 19.419375 11.700953 19.755516 11.882813 20.103516 11.882812 C 20.271516 11.882812 20.441656 11.84 20.597656 11.75 C 24.732656 9.392 29.615891 8.509625 34.337891 9.265625 C 34.883891 9.353625 35.394422 8.9835 35.482422 8.4375 C 35.570422 7.8915 35.199297 7.3780156 34.654297 7.2910156 C 33.361547 7.0837656 32.057109 6.9895156 30.757812 7.0039062 z M 38.658203 8.3867188 C 38.268813 8.4034062 37.907672 8.6466562 37.763672 9.0351562 C 37.570672 9.5531563 37.833562 10.130266 38.351562 10.322266 C 39.061563 10.588266 39.767172 10.895234 40.451172 11.240234 C 40.596172 11.313234 40.749391 11.347656 40.900391 11.347656 C 41.265391 11.347656 41.618922 11.147828 41.794922 10.798828 C 42.042922 10.307828 41.844563 9.7040781 41.351562 9.4550781 C 40.603563 9.0770781 39.829781 8.7392187 39.050781 8.4492188 C 38.921531 8.4012187 38.788 8.3811563 38.658203 8.3867188 z M 44.986328 15.544922 C 46.058328 18.708922 45.323594 20.994484 45.058594 21.646484 C 44.913594 22.003484 44.988047 22.413266 45.248047 22.697266 C 46.982047 24.593266 47.861328 26.892203 47.861328 29.533203 C 47.861328 39.668203 41.85075 41.702516 35.96875 42.353516 C 35.57275 42.397516 35.241047 42.670781 35.123047 43.050781 C 35.005047 43.430781 35.124781 43.843516 35.425781 44.103516 C 36.214781 44.781516 38 47.713 38 50 L 37.998047 55.255859 C 37.998047 55.271859 38.005063 56.144188 38.289062 56.992188 C 35.969063 57.644187 33.526 58 31 58 C 28.47 58 26.022266 57.642281 23.697266 56.988281 C 23.987266 56.138281 23.996094 55.265047 23.996094 55.248047 L 23.998047 54.712891 C 24.003047 54.261891 24.01 53.649141 24 51.994141 C 23.998 51.692141 23.86 51.408703 23.625 51.220703 C 23.391 51.032703 23.083109 50.961438 22.787109 51.023438 C 16.071109 52.488438 14.616547 47.640453 14.560547 47.439453 C 14.550547 47.403453 14.539391 47.369937 14.525391 47.335938 C 13.566391 44.897937 12.301875 43.657703 11.546875 43.095703 C 13.176875 43.669703 14.087422 45.258969 14.107422 45.292969 C 16.752422 49.821969 21.119203 49.938062 23.408203 48.914062 C 23.722203 48.773063 23.942234 48.480625 23.990234 48.140625 C 24.192234 46.710625 25.760688 44.820047 26.554688 44.123047 C 26.852687 43.862047 26.967609 43.450266 26.849609 43.072266 C 26.731609 42.694266 26.403766 42.422906 26.009766 42.378906 C 20.142766 41.710906 14.144531 39.661203 14.144531 29.533203 C 14.144531 26.894203 15.024719 24.595266 16.761719 22.697266 C 17.023719 22.412266 17.096219 22.003531 16.949219 21.644531 C 16.683219 20.994531 15.946578 18.715781 17.017578 15.550781 C 17.867578 15.577781 19.939594 15.941547 23.433594 18.310547 C 23.677594 18.475547 23.982672 18.526266 24.263672 18.447266 C 26.354672 17.865266 28.687 17.552969 31 17.542969 C 33.319 17.553969 35.651094 17.865266 37.746094 18.447266 C 38.029094 18.526266 38.332219 18.475547 38.574219 18.310547 C 42.087219 15.931547 44.161328 15.574922 44.986328 15.544922 z M 21.373047 34.394531 C 20.986094 34.346391 20.591016 34.527469 20.384766 34.886719 L 19.384766 36.617188 C 19.108766 37.096187 19.272 37.708375 19.75 37.984375 C 19.907 38.075375 20.078047 38.117187 20.248047 38.117188 C 20.594047 38.117188 20.930234 37.938187 21.115234 37.617188 L 22.115234 35.886719 C 22.392234 35.408719 22.229 34.798484 21.75 34.521484 C 21.6305 34.452484 21.502031 34.410578 21.373047 34.394531 z M 40.625 34.394531 C 40.496266 34.410625 40.369 34.452234 40.25 34.521484 C 39.771 34.797484 39.607766 35.410672 39.884766 35.888672 L 40.884766 37.619141 C 41.070766 37.940141 41.405953 38.119141 41.751953 38.119141 C 41.921953 38.119141 42.093 38.075375 42.25 37.984375 C 42.729 37.708375 42.892234 37.097141 42.615234 36.619141 L 41.615234 34.888672 C 41.407484 34.529422 41.011203 34.34625 40.625 34.394531 z M 36.185547 36.34375 C 36.056844 36.325844 35.920609 36.333641 35.787109 36.369141 C 35.254109 36.512141 34.937078 37.05975 35.080078 37.59375 L 35.599609 39.525391 C 35.718609 39.972391 36.122453 40.267578 36.564453 40.267578 C 36.650453 40.267578 36.737219 40.255422 36.824219 40.232422 C 37.357219 40.089422 37.67425 39.541812 37.53125 39.007812 L 37.013672 37.076172 C 36.906422 36.675672 36.571656 36.397469 36.185547 36.34375 z M 25.816406 36.345703 C 25.430578 36.399422 25.093578 36.675672 24.986328 37.076172 L 24.46875 39.009766 C 24.32575 39.542766 24.642781 40.091375 25.175781 40.234375 C 25.262781 40.257375 25.349547 40.267578 25.435547 40.267578 C 25.876547 40.267578 26.281391 39.974344 26.400391 39.527344 L 26.919922 37.595703 C 27.062922 37.062703 26.745891 36.512141 26.212891 36.369141 C 26.079891 36.333641 25.945016 36.327797 25.816406 36.345703 z M 31 37 C 30.447 37 30 37.447 30 38 L 30 40 C 30 40.553 30.447 41 31 41 C 31.553 41 32 40.553 32 40 L 32 38 C 32 37.447 31.553 37 31 37 z"}));
	}
	
	Github.displayName = "Github";
	
	Github.defaultProps = {"viewBox":"0 0 64 64","width":"100","height":"100","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Github;
	
	Github.default = Github;


/***/ }),

/***/ "./src/pages/index/index.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".IndexPage-UseDiagram{text-align:center;margin-top:50px}.IndexPage-UseDiagram-Examples h2{margin:10px 0 5px}.IndexPage-UseDiagram-Examples>div{width:30%}.IndexPage-TabControl{max-width:500px;margin:0 auto;margin-bottom:30px}.IndexPage-Tabs{display:flex}.IndexPage-Tabs>a{margin-right:10px}@media (max-height:640px){.IndexPage-UseDiagram-Arrows svg{display:none!important}.IndexPage-UseDiagram-Arrows svg:nth-child(2){display:flex!important}.IndexPage-UseDiagram-Examples{flex-wrap:wrap}.IndexPage-UseDiagram-Examples>div{width:90%}}.IndexPage-Hero-Slides{flex:5;padding:20px 20px 20px 90px}.IndexPage-Hero-Slides img{width:90%}.IndexPage-Features{margin-top:80px;flex-wrap:wrap;font-weight:400}.IndexPage-ButtonBar,.IndexPage-Features{display:flex;flex-direction:row;justify-content:center}.IndexPage-ButtonBar{align-items:center}", ""]);
	
	// exports


/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/repo/website/node_modules/babel-preset-react/lib/index.js\",\"/repo/website/node_modules/babel-preset-es2015/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-1/lib/index.js\",\"/repo/website/node_modules/babel-preset-env/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/repo/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/repo/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactResponsiveGrid = __webpack_require__("./node_modules/react-responsive-grid/dist/index.js");
	
	var _get = __webpack_require__("./node_modules/lodash/get.js");
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__("./src/layouts/Footer.js");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Button = __webpack_require__("./src/components/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Feature = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/repo/website/node_modules/babel-preset-react/lib/index.js\",\"/repo/website/node_modules/babel-preset-es2015/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-1/lib/index.js\",\"/repo/website/node_modules/babel-preset-env/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/repo/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/repo/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index/Feature.js");
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _mail = __webpack_require__("./src/pages/index/mail.svgc");
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _network = __webpack_require__("./src/pages/index/network.svgc");
	
	var _network2 = _interopRequireDefault(_network);
	
	var _slack = __webpack_require__("./src/pages/index/slack.svgc");
	
	var _slack2 = _interopRequireDefault(_slack);
	
	var _stop = __webpack_require__("./src/pages/index/stop.svgc");
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _webpack = __webpack_require__("./src/pages/index/webpack.svgc");
	
	var _webpack2 = _interopRequireDefault(_webpack);
	
	var _gears = __webpack_require__("./src/pages/index/gears.svgc");
	
	var _gears2 = _interopRequireDefault(_gears);
	
	var _github = __webpack_require__("./src/pages/index/github.svgc");
	
	var _github2 = _interopRequireDefault(_github);
	
	var _pullrequests = __webpack_require__("./src/pages/index/pullrequests.png");
	
	var _pullrequests2 = _interopRequireDefault(_pullrequests);
	
	var _console = __webpack_require__("./src/pages/index/console.png");
	
	var _console2 = _interopRequireDefault(_console);
	
	var _dashboard = __webpack_require__("./src/pages/index/dashboard.png");
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _Header = __webpack_require__("./src/layouts/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _logo = __webpack_require__("./src/logo.png");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__("./src/pages/index/index.css");
	
	var _ga = __webpack_require__("./src/utils/ga.js");
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _Arrow = __webpack_require__("./src/components/Arrow.js");
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _SignupAndPlansSlide = __webpack_require__("./src/components/SignupAndPlansSlide.js");
	
	var _SignupAndPlansSlide2 = _interopRequireDefault(_SignupAndPlansSlide);
	
	var _HeroSlide = __webpack_require__("./src/components/HeroSlide.js");
	
	var _HeroSlide2 = _interopRequireDefault(_HeroSlide);
	
	var _CodeSampleTabs = __webpack_require__("./src/components/CodeSampleTabs.js");
	
	var _CodeSampleTabs2 = _interopRequireDefault(_CodeSampleTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IndexPage.__proto__ || Object.getPrototypeOf(IndexPage)).call.apply(_ref, [this].concat(args))), _this), _this.showMailingListPopUp = function () {
	      _this.refs.mailchimp.open();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(IndexPage, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "IndexPage" },
	        _react2.default.createElement(_reactHelmet2.default, { title: "BundleCop Is Keeping Track of Your App's Size." }),
	        _react2.default.createElement(_HeroSlide2.default, {
	          hideLogo: true,
	          bold: true,
	          title: _react2.default.createElement(
	            "span",
	            null,
	            "Hi, I am the ",
	            _react2.default.createElement(
	              "nobr",
	              null,
	              _react2.default.createElement("img", { src: _logo2.default }),
	              "."
	            )
	          ),
	          subtitle: "I\u2019ll tell you when your app becomes too large."
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: { borderBottom: '1px solid #eaeaea' } },
	          _react2.default.createElement(
	            _reactResponsiveGrid.Container,
	            {
	              style: {
	                maxWidth: (0, _typography.rhythm)(35),
	                padding: (0, _typography.rhythm)(1.5) + " 0",
	                paddingTop: 0
	              },
	              className: "IndexPage-UseDiagram"
	            },
	            _react2.default.createElement(_CodeSampleTabs2.default, {
	              tabs: [{ id: 'cli', code: this.props.data.cli.html, label: 'CLI' }, { id: 'webpack', code: this.props.data.webpack.html, label: 'Webpack' }],
	              initial: "cli"
	            }),
	            _react2.default.createElement(
	              "div",
	              { style: {
	                  display: 'flex',
	                  alignItems: 'flex-start',
	                  justifyContent: 'center'
	                }, className: "IndexPage-UseDiagram-Arrows" },
	              _react2.default.createElement(_Arrow2.default, {
	                style: { width: '300px', height: '100px' },
	                length: 160,
	                angle: 220
	              }),
	              _react2.default.createElement(_Arrow2.default, {
	                style: { width: '300px', height: '100px' },
	                length: 180,
	                angle: 180
	              }),
	              _react2.default.createElement(_Arrow2.default, {
	                style: { width: '300px', height: '100px' },
	                length: 200,
	                angle: 140
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: {
	                  display: 'flex',
	                  alignItems: 'flex-start',
	                  justifyContent: 'space-around'
	                }, className: "IndexPage-UseDiagram-Examples" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Check pull requests"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "BundleCop updates pull requests with size information."
	                ),
	                _react2.default.createElement("img", { src: _pullrequests2.default })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Keep track"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Which commits are responsible for a size increase?"
	                ),
	                _react2.default.createElement("img", { src: _dashboard2.default })
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Fail your tests"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "If your chosen limits or thresholds are exceeded, do not allow a build to complete."
	                ),
	                _react2.default.createElement("img", { src: _console2.default })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactResponsiveGrid.Container,
	          {
	            style: {
	              maxWidth: (0, _typography.rhythm)(35),
	              padding: (0, _typography.rhythm)(1.5) + " 0",
	              paddingTop: 0
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "IndexPage-Features" },
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _stop2.default },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Keep your file sizes down."
	              ),
	              " ",
	              " ",
	              "Performance is a feature. Small file sizes are key to webapp performance, especially on mobile. BundleCop works by helping you report file sizes to our analyzer."
	            ),
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _webpack2.default },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "webpack Plugin."
	              ),
	              " Easily send data from any webpack-based project.",
	              " ",
	              " ",
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/docs/webpack" },
	                "Read more."
	              )
	            ),
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _gears2.default },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Use with any tech or stack."
	              ),
	              " Using our CLI, you can monitor the size of your .exe, .ipa, image files or anything else.",
	              " ",
	              " ",
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/docs/cli" },
	                "Read more."
	              )
	            ),
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _network2.default },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "We support your CI."
	              ),
	              " We get data like branch name or parent commit from the CI and repo, so we know what to compare to.",
	              " ",
	              " ",
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/docs/tools" },
	                "See supported tools."
	              )
	            ),
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _mail2.default, comingSoon: true },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Receive notifications"
	              ),
	              " when file sizes exceed limits."
	            ),
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _slack2.default, comingSoon: true },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Send to Slack."
	              ),
	              " We'll send updates to your team channels."
	            ),
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _github2.default, comingSoon: true },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Integrates with Github."
	              ),
	              " Can post status updates to pull requests."
	            ),
	            _react2.default.createElement(
	              _Feature2.default,
	              { Icon: _webpack2.default, comingSoon: true },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Browse webpack bundles."
	              ),
	              " Look inside your bundles to know why they are big. Any stat is ready to browse."
	            )
	          )
	        ),
	        _react2.default.createElement(_SignupAndPlansSlide2.default, {
	          prompt: "Fight dependency-creep, make your app fast"
	        }),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return IndexPage;
	}(_react2.default.Component);
	
	IndexPage.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ "./src/pages/index/mail.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Mail (props) {
	    return React.createElement("svg",props,React.createElement("path",{"style":{"lineHeight":"normal","textIndent":"0","textAlign":"start","textDecorationLine":"none","textDecorationStyle":"solid","textDecorationColor":"#000","textTransform":"none","blockProgression":"tb","isolation":"auto","mixBlendMode":"normal"},"d":"M 40 7.9804688 C 38.385728 7.9804688 36.771565 8.4920897 35.417969 9.515625 L 9 29.501953 L 9 72 L 71 72 L 71 29.501953 L 44.582031 9.515625 C 43.228435 8.4920897 41.614272 7.9804688 40 7.9804688 z M 40 9.9765625 C 41.187728 9.9765625 42.374597 10.354863 43.375 11.111328 L 68.367188 30.019531 L 60 36.642578 L 60 26 L 20 26 L 20 36.642578 L 11.632812 30.019531 L 36.625 11.111328 C 37.625403 10.354863 38.812272 9.9765625 40 9.9765625 z M 22 28 L 58 28 L 58 38.224609 L 45.652344 48 L 34.347656 48 L 22 38.224609 L 22 28 z M 11 32.066406 L 33.652344 50 L 46.347656 50 L 69 32.066406 L 69 70 L 11 70 L 11 32.066406 z M 30 33 L 30 35 L 51 35 L 51 33 L 30 33 z M 30 38 L 30 40 L 48 40 L 48 38 L 30 38 z M 16 40 A 1 1 0 0 0 15 41 A 1 1 0 0 0 16 42 A 1 1 0 0 0 17 41 A 1 1 0 0 0 16 40 z M 64 40 A 1 1 0 0 0 63 41 A 1 1 0 0 0 64 42 A 1 1 0 0 0 65 41 A 1 1 0 0 0 64 40 z M 16 44 A 1 1 0 0 0 15 45 A 1 1 0 0 0 16 46 A 1 1 0 0 0 17 45 A 1 1 0 0 0 16 44 z M 64 44 A 1 1 0 0 0 63 45 A 1 1 0 0 0 64 46 A 1 1 0 0 0 65 45 A 1 1 0 0 0 64 44 z M 16 48 A 1 1 0 0 0 15 49 A 1 1 0 0 0 16 50 A 1 1 0 0 0 17 49 A 1 1 0 0 0 16 48 z M 64 48 A 1 1 0 0 0 63 49 A 1 1 0 0 0 64 50 A 1 1 0 0 0 65 49 A 1 1 0 0 0 64 48 z M 16 52 A 1 1 0 0 0 15 53 A 1 1 0 0 0 16 54 A 1 1 0 0 0 17 53 A 1 1 0 0 0 16 52 z M 64 52 A 1 1 0 0 0 63 53 A 1 1 0 0 0 64 54 A 1 1 0 0 0 65 53 A 1 1 0 0 0 64 52 z M 16 56 A 1 1 0 0 0 15 57 A 1 1 0 0 0 16 58 A 1 1 0 0 0 17 57 A 1 1 0 0 0 16 56 z M 64 56 A 1 1 0 0 0 63 57 A 1 1 0 0 0 64 58 A 1 1 0 0 0 65 57 A 1 1 0 0 0 64 56 z M 16 60 A 1 1 0 0 0 15 61 A 1 1 0 0 0 16 62 A 1 1 0 0 0 17 61 A 1 1 0 0 0 16 60 z M 64 60 A 1 1 0 0 0 63 61 A 1 1 0 0 0 64 62 A 1 1 0 0 0 65 61 A 1 1 0 0 0 64 60 z M 16 64 A 1 1 0 0 0 15 65 A 1 1 0 0 0 16 66 A 1 1 0 0 0 17 65 A 1 1 0 0 0 16 64 z M 20 64 A 1 1 0 0 0 19 65 A 1 1 0 0 0 20 66 A 1 1 0 0 0 21 65 A 1 1 0 0 0 20 64 z M 24 64 A 1 1 0 0 0 23 65 A 1 1 0 0 0 24 66 A 1 1 0 0 0 25 65 A 1 1 0 0 0 24 64 z M 28 64 A 1 1 0 0 0 27 65 A 1 1 0 0 0 28 66 A 1 1 0 0 0 29 65 A 1 1 0 0 0 28 64 z M 32 64 A 1 1 0 0 0 31 65 A 1 1 0 0 0 32 66 A 1 1 0 0 0 33 65 A 1 1 0 0 0 32 64 z M 36 64 A 1 1 0 0 0 35 65 A 1 1 0 0 0 36 66 A 1 1 0 0 0 37 65 A 1 1 0 0 0 36 64 z M 40 64 A 1 1 0 0 0 39 65 A 1 1 0 0 0 40 66 A 1 1 0 0 0 41 65 A 1 1 0 0 0 40 64 z M 44 64 A 1 1 0 0 0 43 65 A 1 1 0 0 0 44 66 A 1 1 0 0 0 45 65 A 1 1 0 0 0 44 64 z M 48 64 A 1 1 0 0 0 47 65 A 1 1 0 0 0 48 66 A 1 1 0 0 0 49 65 A 1 1 0 0 0 48 64 z M 52 64 A 1 1 0 0 0 51 65 A 1 1 0 0 0 52 66 A 1 1 0 0 0 53 65 A 1 1 0 0 0 52 64 z M 56 64 A 1 1 0 0 0 55 65 A 1 1 0 0 0 56 66 A 1 1 0 0 0 57 65 A 1 1 0 0 0 56 64 z M 60 64 A 1 1 0 0 0 59 65 A 1 1 0 0 0 60 66 A 1 1 0 0 0 61 65 A 1 1 0 0 0 60 64 z M 64 64 A 1 1 0 0 0 63 65 A 1 1 0 0 0 64 66 A 1 1 0 0 0 65 65 A 1 1 0 0 0 64 64 z"}));
	}
	
	Mail.displayName = "Mail";
	
	Mail.defaultProps = {"viewBox":"0 0 80 80","width":"80","height":"80","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Mail;
	
	Mail.default = Mail;


/***/ }),

/***/ "./src/pages/index/network.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Network (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M 36 6 C 34.35503 6 33 7.3550302 33 9 L 33 12 A 1 1 0 0 0 32 13 A 1 1 0 0 0 33 14 L 33 17 C 33 18.439349 34.037075 19.657602 35.398438 19.939453 C 35.592918 19.979718 35.794379 20 36 20 L 44 20 C 45.439349 20 46.657602 18.962925 46.939453 17.601562 C 46.979718 17.407082 47 17.205621 47 17 L 47 14 A 1 1 0 0 0 48 13 A 1 1 0 0 0 47 12 L 47 9 C 47 7.3550302 45.64497 6 44 6 L 36 6 z M 36 8 L 44 8 C 44.56503 8 45 8.4349698 45 9 L 45 17 C 45 17.56503 44.56503 18 44 18 L 36 18 C 35.43497 18 35 17.56503 35 17 L 35 9 C 35 8.8587424 35.026565 8.7257044 35.076172 8.6054688 C 35.120988 8.496845 35.191629 8.4043776 35.269531 8.3203125 C 35.29124 8.2969676 35.315924 8.2769577 35.339844 8.2558594 C 35.40339 8.1998146 35.473588 8.1514925 35.550781 8.1132812 C 35.581385 8.0981882 35.610151 8.0803458 35.642578 8.0683594 C 35.753633 8.0273042 35.872072 8 36 8 z M 13 12 A 1 1 0 0 0 12 13 A 1 1 0 0 0 13 14 A 1 1 0 0 0 14 13 A 1 1 0 0 0 13 12 z M 17 12 A 1 1 0 0 0 16 13 A 1 1 0 0 0 17 14 A 1 1 0 0 0 18 13 A 1 1 0 0 0 17 12 z M 21 12 A 1 1 0 0 0 20 13 A 1 1 0 0 0 21 14 A 1 1 0 0 0 22 13 A 1 1 0 0 0 21 12 z M 25 12 A 1 1 0 0 0 24 13 A 1 1 0 0 0 25 14 A 1 1 0 0 0 26 13 A 1 1 0 0 0 25 12 z M 29 12 A 1 1 0 0 0 28 13 A 1 1 0 0 0 29 14 A 1 1 0 0 0 30 13 A 1 1 0 0 0 29 12 z M 51 12 A 1 1 0 0 0 50 13 A 1 1 0 0 0 51 14 A 1 1 0 0 0 52 13 A 1 1 0 0 0 51 12 z M 55 12 A 1 1 0 0 0 54 13 A 1 1 0 0 0 55 14 A 1 1 0 0 0 56 13 A 1 1 0 0 0 55 12 z M 59 12 A 1 1 0 0 0 58 13 A 1 1 0 0 0 59 14 A 1 1 0 0 0 60 13 A 1 1 0 0 0 59 12 z M 63 12 A 1 1 0 0 0 62 13 A 1 1 0 0 0 63 14 A 1 1 0 0 0 64 13 A 1 1 0 0 0 63 12 z M 67 12 A 1 1 0 0 0 66 13 A 1 1 0 0 0 67 14 A 1 1 0 0 0 68 13 A 1 1 0 0 0 67 12 z M 13 16 A 1 1 0 0 0 12 17 A 1 1 0 0 0 13 18 A 1 1 0 0 0 14 17 A 1 1 0 0 0 13 16 z M 67 16 A 1 1 0 0 0 66 17 A 1 1 0 0 0 67 18 A 1 1 0 0 0 68 17 A 1 1 0 0 0 67 16 z M 13 20 A 1 1 0 0 0 12 21 A 1 1 0 0 0 13 22 A 1 1 0 0 0 14 21 A 1 1 0 0 0 13 20 z M 67 20 A 1 1 0 0 0 66 21 A 1 1 0 0 0 67 22 A 1 1 0 0 0 68 21 A 1 1 0 0 0 67 20 z M 13 24 A 1 1 0 0 0 12 25 A 1 1 0 0 0 13 26 A 1 1 0 0 0 14 25 A 1 1 0 0 0 13 24 z M 67 24 A 1 1 0 0 0 66 25 A 1 1 0 0 0 67 26 A 1 1 0 0 0 68 25 A 1 1 0 0 0 67 24 z M 13 28 A 1 1 0 0 0 12 29 A 1 1 0 0 0 13 30 A 1 1 0 0 0 14 29 A 1 1 0 0 0 13 28 z M 67 28 A 1 1 0 0 0 66 29 A 1 1 0 0 0 67 30 A 1 1 0 0 0 68 29 A 1 1 0 0 0 67 28 z M 13 32 A 1 1 0 0 0 12 33 L 9 33 C 7.3550302 33 6 34.35503 6 36 L 6 44 C 6 45.64497 7.3550302 47 9 47 L 12 47 A 1 1 0 0 0 13 48 A 1 1 0 0 0 14 47 L 17 47 C 18.439349 47 19.657602 45.962925 19.939453 44.601562 C 19.979718 44.407082 20 44.205621 20 44 L 20 36 C 20 35.794379 19.979718 35.592918 19.939453 35.398438 C 19.899189 35.203957 19.838087 35.01707 19.761719 34.837891 C 19.303509 33.762817 18.233728 33 17 33 L 14 33 A 1 1 0 0 0 13 32 z M 67 32 A 1 1 0 0 0 66 33 L 63 33 C 62.794379 33 62.592918 33.020282 62.398438 33.060547 C 61.207245 33.307167 60.26399 34.27137 60.046875 35.472656 C 60.015859 35.644269 60 35.820081 60 36 L 60 44 C 60 45.64497 61.35503 47 63 47 L 66 47 A 1 1 0 0 0 67 48 A 1 1 0 0 0 68 47 L 71 47 C 72.439349 47 73.657602 45.962925 73.939453 44.601562 C 73.979718 44.407082 74 44.205621 74 44 L 74 36 C 74 35.794379 73.979718 35.592918 73.939453 35.398438 C 73.697867 34.231555 72.768445 33.302133 71.601562 33.060547 C 71.407082 33.020282 71.205621 33 71 33 L 68 33 A 1 1 0 0 0 67 32 z M 9 35 L 17 35 C 17.56503 35 18 35.43497 18 36 L 18 44 C 18 44.56503 17.56503 45 17 45 L 9 45 C 8.4349698 45 8 44.56503 8 44 L 8 36 C 8 35.858742 8.0265649 35.725705 8.0761719 35.605469 C 8.120988 35.496845 8.1916285 35.404378 8.2695312 35.320312 C 8.2912401 35.296968 8.3159241 35.276958 8.3398438 35.255859 C 8.4033897 35.199815 8.4735884 35.151493 8.5507812 35.113281 C 8.581385 35.098188 8.6101513 35.080346 8.6425781 35.068359 C 8.7536331 35.027304 8.8720722 35 9 35 z M 63 35 L 71 35 C 71.56503 35 72 35.43497 72 36 L 72 44 C 72 44.56503 71.56503 45 71 45 L 63 45 C 62.43497 45 62 44.56503 62 44 L 62 36 C 62 35.858742 62.026565 35.725705 62.076172 35.605469 C 62.224993 35.244761 62.576228 35 63 35 z M 13 50 A 1 1 0 0 0 12 51 A 1 1 0 0 0 13 52 A 1 1 0 0 0 14 51 A 1 1 0 0 0 13 50 z M 67 50 A 1 1 0 0 0 66 51 A 1 1 0 0 0 67 52 A 1 1 0 0 0 68 51 A 1 1 0 0 0 67 50 z M 13 54 A 1 1 0 0 0 12 55 A 1 1 0 0 0 13 56 A 1 1 0 0 0 14 55 A 1 1 0 0 0 13 54 z M 67 54 A 1 1 0 0 0 66 55 A 1 1 0 0 0 67 56 A 1 1 0 0 0 68 55 A 1 1 0 0 0 67 54 z M 13 58 A 1 1 0 0 0 12 59 A 1 1 0 0 0 13 60 A 1 1 0 0 0 14 59 A 1 1 0 0 0 13 58 z M 67 58 A 1 1 0 0 0 66 59 A 1 1 0 0 0 67 60 A 1 1 0 0 0 68 59 A 1 1 0 0 0 67 58 z M 36 60 C 34.560651 60 33.342398 61.037075 33.060547 62.398438 C 33.020282 62.592918 33 62.794379 33 63 L 33 66 A 1 1 0 0 0 32 67 A 1 1 0 0 0 33 68 L 33 71 C 33 72.64497 34.35503 74 36 74 L 44 74 C 45.439349 74 46.657602 72.962925 46.939453 71.601562 C 46.979718 71.407082 47 71.205621 47 71 L 47 68 A 1 1 0 0 0 48 67 A 1 1 0 0 0 47 66 L 47 63 C 47 61.35503 45.64497 60 44 60 L 36 60 z M 13 62 A 1 1 0 0 0 12 63 A 1 1 0 0 0 13 64 A 1 1 0 0 0 14 63 A 1 1 0 0 0 13 62 z M 36 62 L 44 62 C 44.56503 62 45 62.43497 45 63 L 45 71 C 45 71.56503 44.56503 72 44 72 L 36 72 C 35.43497 72 35 71.56503 35 71 L 35 63 C 35 62.858742 35.026565 62.725705 35.076172 62.605469 C 35.224993 62.244761 35.576228 62 36 62 z M 67 62 A 1 1 0 0 0 66 63 A 1 1 0 0 0 67 64 A 1 1 0 0 0 68 63 A 1 1 0 0 0 67 62 z M 13 66 A 1 1 0 0 0 12 67 A 1 1 0 0 0 13 68 A 1 1 0 0 0 14 67 A 1 1 0 0 0 13 66 z M 17 66 A 1 1 0 0 0 16 67 A 1 1 0 0 0 17 68 A 1 1 0 0 0 18 67 A 1 1 0 0 0 17 66 z M 21 66 A 1 1 0 0 0 20 67 A 1 1 0 0 0 21 68 A 1 1 0 0 0 22 67 A 1 1 0 0 0 21 66 z M 25 66 A 1 1 0 0 0 24 67 A 1 1 0 0 0 25 68 A 1 1 0 0 0 26 67 A 1 1 0 0 0 25 66 z M 29 66 A 1 1 0 0 0 28 67 A 1 1 0 0 0 29 68 A 1 1 0 0 0 30 67 A 1 1 0 0 0 29 66 z M 51 66 A 1 1 0 0 0 50 67 A 1 1 0 0 0 51 68 A 1 1 0 0 0 52 67 A 1 1 0 0 0 51 66 z M 55 66 A 1 1 0 0 0 54 67 A 1 1 0 0 0 55 68 A 1 1 0 0 0 56 67 A 1 1 0 0 0 55 66 z M 59 66 A 1 1 0 0 0 58 67 A 1 1 0 0 0 59 68 A 1 1 0 0 0 60 67 A 1 1 0 0 0 59 66 z M 63 66 A 1 1 0 0 0 62 67 A 1 1 0 0 0 63 68 A 1 1 0 0 0 64 67 A 1 1 0 0 0 63 66 z M 67 66 A 1 1 0 0 0 66 67 A 1 1 0 0 0 67 68 A 1 1 0 0 0 68 67 A 1 1 0 0 0 67 66 z"}));
	}
	
	Network.displayName = "Network";
	
	Network.defaultProps = {"viewBox":"0 0 80 80","width":"80","height":"80","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Network;
	
	Network.default = Network;


/***/ }),

/***/ "./src/pages/index/pullrequests.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pullrequests.a14ac403.png";

/***/ }),

/***/ "./src/pages/index/slack.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Slack (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M 36.677734 4.09375 C 36.094305 4.0754629 35.505609 4.1439531 34.927734 4.2988281 C 31.732734 5.1548281 29.828547 8.4504844 30.685547 11.646484 L 31.720703 15.511719 L 23.992188 17.582031 L 22.957031 13.71875 C 22.544031 12.17675 21.554156 10.881406 20.160156 10.066406 C 18.767156 9.2734063 17.151375 9.0635625 15.609375 9.4765625 C 14.062375 9.8915625 12.768797 10.883484 11.966797 12.271484 C 11.164797 13.660484 10.950234 15.276219 11.365234 16.824219 L 12.402344 20.689453 L 8.5371094 21.724609 C 6.9901094 22.139609 5.6965313 23.131531 4.8945312 24.519531 C 4.0925312 25.908531 3.8799219 27.524266 4.2949219 29.072266 C 5.0119219 31.749266 7.4427969 33.519531 10.091797 33.519531 C 10.603797 33.519531 11.124578 33.453453 11.642578 33.314453 L 15.507812 32.279297 L 17.578125 40.007812 L 13.714844 41.042969 C 12.167844 41.457969 10.872313 42.451844 10.070312 43.839844 C 9.2683125 45.228844 9.0557031 46.844578 9.4707031 48.392578 C 10.187703 51.070578 12.618578 52.839844 15.267578 52.839844 C 15.779578 52.839844 16.300359 52.773766 16.818359 52.634766 L 20.683594 51.599609 L 21.71875 55.462891 C 22.13375 57.009891 23.124672 58.303469 24.513672 59.105469 C 25.438672 59.639469 26.465859 59.912109 27.505859 59.912109 C 28.026859 59.912109 28.549406 59.844078 29.066406 59.705078 C 30.613406 59.290078 31.908938 58.299156 32.710938 56.910156 C 33.512937 55.522156 33.725547 53.904422 33.310547 52.357422 L 32.275391 48.494141 L 40.003906 46.423828 L 41.037109 50.287109 C 41.452109 51.834109 42.445984 53.127688 43.833984 53.929688 C 44.758984 54.463687 45.784219 54.736328 46.824219 54.736328 C 47.345219 54.736328 47.870719 54.668297 48.386719 54.529297 C 49.933719 54.114297 51.227297 53.122375 52.029297 51.734375 C 52.831297 50.346375 53.043906 48.728641 52.628906 47.181641 L 51.59375 43.318359 L 55.457031 42.283203 C 56.998031 41.870203 58.294375 40.881328 59.109375 39.486328 C 59.905375 38.088328 60.114172 36.471688 59.701172 34.929688 C 59.286172 33.382688 58.29425 32.089109 56.90625 31.287109 C 55.51625 30.484109 53.899516 30.2715 52.353516 30.6875 L 48.488281 31.722656 L 46.417969 23.994141 L 50.28125 22.958984 C 51.82225 22.545984 53.118594 21.556109 53.933594 20.162109 C 54.727594 18.769109 54.936437 17.153328 54.523438 15.611328 C 53.667437 12.415328 50.371781 10.510141 47.175781 11.369141 L 43.310547 12.404297 L 42.275391 8.5390625 C 41.862391 6.9970625 40.872516 5.7036719 39.478516 4.8886719 C 38.607891 4.3924219 37.650117 4.1242285 36.677734 4.09375 z M 36.490234 6.0917969 C 37.182234 6.0917969 37.866469 6.2691406 38.480469 6.6191406 C 39.407469 7.1611406 40.068703 8.0266406 40.345703 9.0566406 L 41.640625 13.886719 L 42.482422 17.029297 L 42.671875 17.736328 C 42.672875 17.741328 42.672828 17.744047 42.673828 17.748047 L 43.191406 19.681641 C 43.193406 19.687641 43.195266 19.690313 43.197266 19.695312 L 46.558594 32.236328 L 38.830078 34.308594 L 36.501953 25.615234 L 34.755859 19.099609 L 32.617188 11.126953 C 32.047188 8.9999531 33.317266 6.7995156 35.447266 6.2285156 C 35.792266 6.1365156 36.142234 6.0917969 36.490234 6.0917969 z M 17.173828 11.267578 C 17.865828 11.267578 18.548109 11.447875 19.162109 11.796875 C 20.089109 12.338875 20.751344 13.204375 21.027344 14.234375 L 22.064453 18.097656 L 16.851562 19.494141 L 14.335938 20.169922 L 13.300781 16.304688 C 13.024781 15.273687 13.166172 14.195531 13.701172 13.269531 C 14.236172 12.343531 15.097906 11.68225 16.128906 11.40625 C 16.473906 11.31425 16.824828 11.267578 17.173828 11.267578 z M 48.494141 13.171875 C 50.351027 13.062801 52.094125 14.265156 52.59375 16.128906 C 52.86875 17.158906 52.728172 18.238109 52.201172 19.162109 C 51.659172 20.089109 50.794625 20.753297 49.765625 21.029297 L 45.900391 22.064453 L 44.503906 16.851562 L 43.830078 14.335938 L 47.695312 13.300781 C 47.961937 13.229781 48.228871 13.187457 48.494141 13.171875 z M 48.607422 15.207031 C 48.478578 15.189141 48.343234 15.196422 48.208984 15.232422 C 47.675984 15.375422 47.358953 15.923031 47.501953 16.457031 L 48.021484 18.390625 C 48.141484 18.837625 48.544328 19.132813 48.986328 19.132812 C 49.071328 19.132812 49.157141 19.121656 49.244141 19.097656 C 49.777141 18.954656 50.094172 18.405094 49.951172 17.871094 L 49.433594 15.939453 C 49.326344 15.539703 48.993953 15.260703 48.607422 15.207031 z M 32.238281 17.441406 L 32.912109 19.957031 L 33.011719 20.324219 C 33.012719 20.330219 33.012672 20.335797 33.013672 20.341797 L 33.53125 22.273438 C 33.53325 22.279438 33.535109 22.284063 33.537109 22.289062 L 34.310547 25.171875 L 25.617188 27.5 L 17.861328 29.578125 L 11.128906 31.380859 C 8.9969063 31.948859 6.7995156 30.682734 6.2285156 28.552734 C 5.9525156 27.521734 6.0949063 26.443578 6.6289062 25.517578 C 7.1629063 24.591578 8.0256406 23.930297 9.0566406 23.654297 L 13.886719 22.359375 L 17.03125 21.517578 L 32.238281 17.441406 z M 29.287109 20.382812 C 29.158266 20.365063 29.024875 20.371453 28.890625 20.408203 C 28.357625 20.551203 28.040594 21.100766 28.183594 21.634766 L 28.701172 23.566406 C 28.821172 24.013406 29.225969 24.308594 29.667969 24.308594 C 29.752969 24.308594 29.838781 24.297438 29.925781 24.273438 C 30.458781 24.130437 30.775813 23.582828 30.632812 23.048828 L 30.115234 21.115234 C 30.007984 20.715484 29.673641 20.436062 29.287109 20.382812 z M 24.457031 21.677734 C 24.328375 21.659969 24.193797 21.666875 24.060547 21.703125 C 23.526547 21.846125 23.210516 22.393734 23.353516 22.927734 L 23.871094 24.859375 C 23.991094 25.306375 24.395891 25.601563 24.837891 25.601562 C 24.922891 25.601562 25.009703 25.590406 25.095703 25.566406 C 25.629703 25.423406 25.945734 24.875797 25.802734 24.341797 L 25.285156 22.410156 C 25.177906 22.009656 24.843 21.731031 24.457031 21.677734 z M 19.625 22.970703 C 19.496391 22.952953 19.363469 22.959344 19.230469 22.996094 C 18.696469 23.139094 18.380437 23.688656 18.523438 24.222656 L 19.042969 26.154297 C 19.162969 26.601297 19.565813 26.896484 20.007812 26.896484 C 20.092813 26.896484 20.179625 26.885328 20.265625 26.861328 C 20.799625 26.718328 21.115656 26.170719 20.972656 25.636719 L 20.455078 23.703125 C 20.347828 23.303375 20.010828 23.023953 19.625 22.970703 z M 14.800781 24.265625 C 14.671938 24.247781 14.536594 24.256719 14.402344 24.292969 C 13.869344 24.435969 13.552313 24.983578 13.695312 25.517578 L 14.212891 27.449219 C 14.332891 27.896219 14.735734 28.191406 15.177734 28.191406 C 15.262734 28.191406 15.3505 28.18025 15.4375 28.15625 C 15.9705 28.01325 16.287531 27.465641 16.144531 26.931641 L 15.626953 24.998047 C 15.519703 24.598297 15.187312 24.319156 14.800781 24.265625 z M 9.96875 25.560547 C 9.8400937 25.54275 9.7055156 25.549437 9.5722656 25.585938 C 9.0382656 25.728938 8.7222344 26.276547 8.8652344 26.810547 L 9.3828125 28.742188 C 9.5028125 29.189187 9.9056562 29.484375 10.347656 29.484375 C 10.432656 29.484375 10.521422 29.473219 10.607422 29.449219 C 11.141422 29.306219 11.457453 28.758609 11.314453 28.224609 L 10.796875 26.292969 C 10.689625 25.893219 10.354719 25.613937 9.96875 25.560547 z M 34.828125 27.101562 L 36.898438 34.828125 L 29.171875 36.900391 L 27.099609 29.171875 L 34.828125 27.101562 z M 25.169922 29.6875 L 28.53125 42.230469 C 28.53225 42.235469 28.53025 42.241094 28.53125 42.246094 L 29.050781 44.177734 C 29.051781 44.182734 29.054641 44.188359 29.056641 44.193359 L 31.382812 52.869141 C 31.657812 53.902141 31.515469 54.98125 30.980469 55.90625 C 30.445469 56.83225 29.583734 57.493531 28.552734 57.769531 C 26.420734 58.338531 24.223344 57.072406 23.652344 54.941406 L 20.462891 43.03125 L 19.771484 40.451172 L 17.441406 31.759766 L 18.875 31.375 L 25.169922 29.6875 z M 53.650391 32.488281 C 54.431937 32.436813 55.21175 32.617078 55.90625 33.017578 C 56.83225 33.551578 57.493531 34.414312 57.769531 35.445312 C 58.045531 36.478313 57.904906 37.557469 57.378906 38.480469 C 56.836906 39.407469 55.970406 40.069703 54.941406 40.345703 L 43.03125 43.537109 L 40.453125 44.228516 L 31.759766 46.556641 L 29.689453 38.828125 L 52.871094 32.617188 C 53.128844 32.548187 53.389875 32.505437 53.650391 32.488281 z M 53.783203 34.525391 C 53.654359 34.507641 53.520969 34.515984 53.386719 34.552734 C 52.853719 34.695734 52.536688 35.243344 52.679688 35.777344 L 53.197266 37.708984 C 53.317266 38.155984 53.720109 38.451172 54.162109 38.451172 C 54.247109 38.451172 54.334875 38.440016 54.421875 38.416016 C 54.954875 38.273016 55.271906 37.725406 55.128906 37.191406 L 54.611328 35.259766 C 54.504078 34.860016 54.169734 34.578641 53.783203 34.525391 z M 48.953125 35.820312 C 48.824422 35.802516 48.690141 35.809203 48.556641 35.845703 C 48.022641 35.988703 47.706609 36.536312 47.849609 37.070312 L 48.367188 39.003906 C 48.487187 39.450906 48.890031 39.744141 49.332031 39.744141 C 49.417031 39.744141 49.505797 39.734938 49.591797 39.710938 C 50.125797 39.567937 50.441828 39.018375 50.298828 38.484375 L 49.78125 36.552734 C 49.674 36.152984 49.339234 35.873703 48.953125 35.820312 z M 44.123047 37.113281 C 43.994391 37.095531 43.859813 37.103875 43.726562 37.140625 C 43.192563 37.283625 42.876531 37.831234 43.019531 38.365234 L 43.537109 40.296875 C 43.657109 40.743875 44.061906 41.039063 44.503906 41.039062 C 44.588906 41.039062 44.675719 41.027906 44.761719 41.003906 C 45.295719 40.860906 45.61175 40.313297 45.46875 39.779297 L 44.951172 37.847656 C 44.843922 37.447906 44.509016 37.166531 44.123047 37.113281 z M 39.294922 38.408203 C 39.166172 38.390437 39.030234 38.397344 38.896484 38.433594 C 38.363484 38.576594 38.046453 39.124203 38.189453 39.658203 L 38.707031 41.591797 C 38.827031 42.038797 39.231828 42.332031 39.673828 42.332031 C 39.758828 42.332031 39.844641 42.322828 39.931641 42.298828 C 40.464641 42.155828 40.781672 41.606266 40.638672 41.072266 L 40.121094 39.140625 C 40.013844 38.740125 39.681172 38.4615 39.294922 38.408203 z M 34.462891 39.703125 C 34.334187 39.685375 34.199906 39.691766 34.066406 39.728516 C 33.532406 39.871516 33.216375 40.419125 33.359375 40.953125 L 33.878906 42.886719 C 33.998906 43.333719 34.40175 43.628906 34.84375 43.628906 C 34.92875 43.628906 35.015563 43.61775 35.101562 43.59375 C 35.635562 43.45075 35.951594 42.901187 35.808594 42.367188 L 35.292969 40.435547 C 35.185719 40.035797 34.849 39.756375 34.462891 39.703125 z M 18.097656 41.9375 L 18.578125 43.732422 L 18.869141 44.820312 C 18.870141 44.825313 18.870094 44.831891 18.871094 44.837891 L 19.388672 46.769531 C 19.390672 46.775531 19.394484 46.779156 19.396484 46.785156 L 20.169922 49.666016 L 16.304688 50.699219 C 15.272687 50.975219 14.195531 50.834781 13.269531 50.300781 C 12.343531 49.765781 11.68225 48.902094 11.40625 47.871094 C 11.13025 46.840094 11.272641 45.763891 11.806641 44.837891 C 12.340641 43.911891 13.203375 43.248656 14.234375 42.972656 L 18.097656 41.9375 z M 49.664062 43.832031 L 50.699219 47.695312 C 50.976219 48.726312 50.832828 49.804469 50.298828 50.730469 C 49.763828 51.656469 48.902094 52.31775 47.871094 52.59375 C 46.840094 52.87075 45.761938 52.727359 44.835938 52.193359 C 43.909937 51.658359 43.248656 50.796625 42.972656 49.765625 L 41.9375 45.902344 L 43.732422 45.421875 L 49.664062 43.832031 z M 15.146484 44.878906 C 15.017781 44.861109 14.881547 44.867797 14.748047 44.904297 C 14.214047 45.047297 13.899969 45.596859 14.042969 46.130859 L 14.560547 48.0625 C 14.680547 48.5095 15.083391 48.804687 15.525391 48.804688 C 15.610391 48.804688 15.697203 48.793531 15.783203 48.769531 C 16.317203 48.626531 16.633234 48.078922 16.490234 47.544922 L 15.974609 45.611328 C 15.867359 45.211578 15.532594 44.932297 15.146484 44.878906 z"}));
	}
	
	Slack.displayName = "Slack";
	
	Slack.defaultProps = {"viewBox":"0 0 64 64","width":"100","height":"100","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Slack;
	
	Slack.default = Slack;


/***/ }),

/***/ "./src/pages/index/stop.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Stop (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M 26.720703 10 C 24.221816 10 21.908056 11.336076 20.658203 13.5 L 7.3808594 36.5 C 6.1308351 38.664221 6.1308351 41.335779 7.3808594 43.5 L 20.658203 66.5 C 21.907921 68.66369 24.220982 70 26.720703 70 L 53.279297 70 C 55.779018 70 58.092079 68.66369 59.341797 66.5 L 72.619141 43.5 C 73.869165 41.335779 73.869165 38.664221 72.619141 36.5 L 59.341797 13.5 C 58.092079 11.33631 55.779018 10 53.279297 10 L 26.720703 10 z M 26.720703 12 L 53.279297 12 C 55.067575 12 56.715093 12.95169 57.609375 14.5 L 70.888672 37.5 C 71.782648 39.047779 71.782648 40.952221 70.888672 42.5 L 57.609375 65.5 C 56.715093 67.04831 55.067575 68 53.279297 68 L 26.720703 68 C 24.932425 68 23.284907 67.04831 22.390625 65.5 L 9.1113281 42.5 C 8.2173524 40.952221 8.2173524 39.047779 9.1113281 37.5 L 22.390625 14.5 C 23.284773 12.951924 24.933591 12 26.720703 12 z M 28 17 A 1 1 0 0 0 27 18 A 1 1 0 0 0 28 19 A 1 1 0 0 0 29 18 A 1 1 0 0 0 28 17 z M 32 17 A 1 1 0 0 0 31 18 A 1 1 0 0 0 32 19 A 1 1 0 0 0 33 18 A 1 1 0 0 0 32 17 z M 36 17 A 1 1 0 0 0 35 18 A 1 1 0 0 0 36 19 A 1 1 0 0 0 37 18 A 1 1 0 0 0 36 17 z M 40 17 A 1 1 0 0 0 39 18 A 1 1 0 0 0 40 19 A 1 1 0 0 0 41 18 A 1 1 0 0 0 40 17 z M 44 17 A 1 1 0 0 0 43 18 A 1 1 0 0 0 44 19 A 1 1 0 0 0 45 18 A 1 1 0 0 0 44 17 z M 48 17 A 1 1 0 0 0 47 18 A 1 1 0 0 0 48 19 A 1 1 0 0 0 49 18 A 1 1 0 0 0 48 17 z M 52 17 A 1 1 0 0 0 51 18 A 1 1 0 0 0 52 19 A 1 1 0 0 0 53 18 A 1 1 0 0 0 52 17 z M 55.027344 21.070312 A 1 1 0 0 0 54.550781 21.205078 A 1 1 0 0 0 54.185547 22.570312 A 1 1 0 0 0 55.550781 22.9375 A 1 1 0 0 0 55.917969 21.570312 A 1 1 0 0 0 55.027344 21.070312 z M 24.900391 21.074219 A 1 1 0 0 0 24.080078 21.574219 A 1 1 0 0 0 24.447266 22.939453 A 1 1 0 0 0 25.8125 22.574219 A 1 1 0 0 0 25.447266 21.207031 A 1 1 0 0 0 24.900391 21.074219 z M 57.027344 24.535156 A 1 1 0 0 0 56.550781 24.667969 A 1 1 0 0 0 56.185547 26.035156 A 1 1 0 0 0 57.550781 26.400391 A 1 1 0 0 0 57.917969 25.035156 A 1 1 0 0 0 57.027344 24.535156 z M 22.900391 24.539062 A 1 1 0 0 0 22.080078 25.037109 A 1 1 0 0 0 22.447266 26.404297 A 1 1 0 0 0 23.8125 26.037109 A 1 1 0 0 0 23.447266 24.671875 A 1 1 0 0 0 22.900391 24.539062 z M 59.027344 28 A 1 1 0 0 0 58.550781 28.132812 A 1 1 0 0 0 58.185547 29.498047 A 1 1 0 0 0 59.550781 29.865234 A 1 1 0 0 0 59.917969 28.498047 A 1 1 0 0 0 59.027344 28 z M 20.900391 28.001953 A 1 1 0 0 0 20.082031 28.5 A 1 1 0 0 0 20.447266 29.867188 A 1 1 0 0 0 21.814453 29.5 A 1 1 0 0 0 21.447266 28.134766 A 1 1 0 0 0 20.900391 28.001953 z M 61.027344 31.462891 A 1 1 0 0 0 60.550781 31.597656 A 1 1 0 0 0 60.185547 32.962891 A 1 1 0 0 0 61.550781 33.328125 A 1 1 0 0 0 61.917969 31.962891 A 1 1 0 0 0 61.027344 31.462891 z M 18.898438 31.464844 A 1 1 0 0 0 18.080078 31.964844 A 1 1 0 0 0 18.445312 33.330078 A 1 1 0 0 0 19.8125 32.964844 A 1 1 0 0 0 19.445312 31.597656 A 1 1 0 0 0 18.898438 31.464844 z M 63.027344 34.927734 A 1 1 0 0 0 62.550781 35.060547 A 1 1 0 0 0 62.185547 36.427734 A 1 1 0 0 0 63.550781 36.792969 A 1 1 0 0 0 63.917969 35.427734 A 1 1 0 0 0 63.027344 34.927734 z M 16.898438 34.929688 A 1 1 0 0 0 16.080078 35.429688 A 1 1 0 0 0 16.445312 36.794922 A 1 1 0 0 0 17.810547 36.429688 A 1 1 0 0 0 17.445312 35.0625 A 1 1 0 0 0 16.898438 34.929688 z M 26.060547 35.173828 C 23.851547 35.173828 22.417969 36.348672 22.417969 38.138672 C 22.417969 39.579672 23.279078 40.493547 24.955078 40.810547 L 26.162109 41.050781 C 27.210109 41.259781 27.609375 41.533016 27.609375 42.041016 C 27.609375 42.644016 27.011578 43.0625 26.142578 43.0625 C 25.180468 43.0625 24.513393 42.639354 24.453125 41.974609 L 22.236328 41.974609 C 22.273328 43.738609 23.734781 44.830078 26.050781 44.830078 C 28.449781 44.830078 29.908203 43.674672 29.908203 41.763672 C 29.908203 40.309672 29.096109 39.491578 27.287109 39.142578 L 26.105469 38.912109 C 25.140469 38.721109 24.734375 38.430687 24.734375 37.929688 C 24.734375 37.319688 25.27475 36.931641 26.09375 36.931641 C 26.91175 36.931641 27.527125 37.382297 27.578125 38.029297 L 29.730469 38.029297 C 29.692469 36.335297 28.206547 35.173828 26.060547 35.173828 z M 44.220703 35.173828 C 41.471703 35.173828 39.699219 37.019094 39.699219 39.996094 C 39.699219 42.980094 41.452703 44.828125 44.220703 44.828125 C 46.975703 44.828125 48.726562 42.979094 48.726562 39.996094 C 48.726563 37.019094 46.975703 35.173828 44.220703 35.173828 z M 31.164062 35.419922 L 31.164062 37.292969 L 33.804688 37.292969 L 33.804688 44.580078 L 36.126953 44.580078 L 36.126953 37.292969 L 38.773438 37.292969 L 38.773438 35.419922 L 31.164062 35.419922 z M 50.455078 35.419922 L 50.455078 44.580078 L 52.783203 44.580078 L 52.783203 41.894531 L 54.326172 41.894531 C 56.363172 41.894531 57.767578 40.618922 57.767578 38.669922 C 57.767578 36.701922 56.434797 35.419922 54.466797 35.419922 L 50.455078 35.419922 z M 44.220703 37.101562 C 45.503703 37.101563 46.361328 38.231094 46.361328 39.996094 C 46.361328 41.767094 45.508703 42.898438 44.220703 42.898438 C 42.918703 42.898438 42.074219 41.767094 42.074219 39.996094 C 42.074219 38.231094 42.931703 37.101562 44.220703 37.101562 z M 52.785156 37.210938 L 53.851562 37.210938 C 54.835562 37.210938 55.412109 37.710781 55.412109 38.675781 C 55.412109 39.627781 54.829844 40.136719 53.839844 40.136719 L 52.785156 40.136719 L 52.785156 37.210938 z M 65.027344 38.390625 A 1 1 0 0 0 64.550781 38.525391 A 1 1 0 0 0 64.185547 39.890625 A 1 1 0 0 0 65.550781 40.257812 A 1 1 0 0 0 65.917969 38.890625 A 1 1 0 0 0 65.027344 38.390625 z M 14.898438 38.394531 A 1 1 0 0 0 14.080078 38.892578 A 1 1 0 0 0 14.445312 40.257812 A 1 1 0 0 0 15.8125 39.892578 A 1 1 0 0 0 15.445312 38.527344 A 1 1 0 0 0 14.898438 38.394531 z M 16.923828 43.070312 A 1 1 0 0 0 16.447266 43.205078 A 1 1 0 0 0 16.080078 44.570312 A 1 1 0 0 0 17.447266 44.9375 A 1 1 0 0 0 17.8125 43.570312 A 1 1 0 0 0 16.923828 43.070312 z M 63.003906 43.074219 A 1 1 0 0 0 62.185547 43.572266 A 1 1 0 0 0 62.550781 44.939453 A 1 1 0 0 0 63.917969 44.572266 A 1 1 0 0 0 63.550781 43.207031 A 1 1 0 0 0 63.003906 43.074219 z M 18.923828 46.535156 A 1 1 0 0 0 18.447266 46.669922 A 1 1 0 0 0 18.080078 48.035156 A 1 1 0 0 0 19.447266 48.400391 A 1 1 0 0 0 19.8125 47.035156 A 1 1 0 0 0 18.923828 46.535156 z M 61.003906 46.539062 A 1 1 0 0 0 60.185547 47.037109 A 1 1 0 0 0 60.550781 48.402344 A 1 1 0 0 0 61.917969 48.037109 A 1 1 0 0 0 61.550781 46.671875 A 1 1 0 0 0 61.003906 46.539062 z M 20.923828 50 A 1 1 0 0 0 20.447266 50.132812 A 1 1 0 0 0 20.080078 51.498047 A 1 1 0 0 0 21.447266 51.865234 A 1 1 0 0 0 21.8125 50.498047 A 1 1 0 0 0 20.923828 50 z M 59.003906 50.001953 A 1 1 0 0 0 58.185547 50.501953 A 1 1 0 0 0 58.550781 51.867188 A 1 1 0 0 0 59.917969 51.501953 A 1 1 0 0 0 59.550781 50.134766 A 1 1 0 0 0 59.003906 50.001953 z M 22.921875 53.462891 A 1 1 0 0 0 22.445312 53.597656 A 1 1 0 0 0 22.080078 54.962891 A 1 1 0 0 0 23.445312 55.330078 A 1 1 0 0 0 23.8125 53.962891 A 1 1 0 0 0 22.921875 53.462891 z M 57.003906 53.466797 A 1 1 0 0 0 56.185547 53.964844 A 1 1 0 0 0 56.550781 55.330078 A 1 1 0 0 0 57.917969 54.964844 A 1 1 0 0 0 57.550781 53.599609 A 1 1 0 0 0 57.003906 53.466797 z M 24.921875 56.927734 A 1 1 0 0 0 24.445312 57.060547 A 1 1 0 0 0 24.080078 58.425781 A 1 1 0 0 0 25.445312 58.792969 A 1 1 0 0 0 25.8125 57.425781 A 1 1 0 0 0 24.921875 56.927734 z M 55.003906 56.929688 A 1 1 0 0 0 54.185547 57.429688 A 1 1 0 0 0 54.550781 58.794922 A 1 1 0 0 0 55.917969 58.429688 A 1 1 0 0 0 55.550781 57.0625 A 1 1 0 0 0 55.003906 56.929688 z M 28 61 A 1 1 0 0 0 27 62 A 1 1 0 0 0 28 63 A 1 1 0 0 0 29 62 A 1 1 0 0 0 28 61 z M 32 61 A 1 1 0 0 0 31 62 A 1 1 0 0 0 32 63 A 1 1 0 0 0 33 62 A 1 1 0 0 0 32 61 z M 36 61 A 1 1 0 0 0 35 62 A 1 1 0 0 0 36 63 A 1 1 0 0 0 37 62 A 1 1 0 0 0 36 61 z M 40 61 A 1 1 0 0 0 39 62 A 1 1 0 0 0 40 63 A 1 1 0 0 0 41 62 A 1 1 0 0 0 40 61 z M 44 61 A 1 1 0 0 0 43 62 A 1 1 0 0 0 44 63 A 1 1 0 0 0 45 62 A 1 1 0 0 0 44 61 z M 48 61 A 1 1 0 0 0 47 62 A 1 1 0 0 0 48 63 A 1 1 0 0 0 49 62 A 1 1 0 0 0 48 61 z M 52 61 A 1 1 0 0 0 51 62 A 1 1 0 0 0 52 63 A 1 1 0 0 0 53 62 A 1 1 0 0 0 52 61 z"}));
	}
	
	Stop.displayName = "Stop";
	
	Stop.defaultProps = {"viewBox":"0 0 80 80","width":"80","height":"80","style":{"fill":"rgb(255, 255, 255)"}};
	
	module.exports = Stop;
	
	Stop.default = Stop;


/***/ }),

/***/ "./src/pages/index/webpack.svgc":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/react/react.js");
	
	function Webpack (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Asset 2"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("polygon",{"points":"204.95 73.09 104.71 143.13 4.48 73.09 104.71 3.05 204.95 73.09","fill":"none","stroke":"#231f20","strokeMiterlimit":"10","strokeWidth":"5","key":0}),React.createElement("polygon",{"points":"204.95 195.37 104.71 265.42 4.48 195.37 104.71 125.33 204.95 195.37","fill":"none","stroke":"#231f20","strokeMiterlimit":"10","strokeWidth":"5","key":1}),React.createElement("line",{"x1":"206.76","y1":"195.37","x2":"207.14","y2":"73.09","fill":"none","stroke":"#231f20","strokeMiterlimit":"10","strokeWidth":"5","key":2}),React.createElement("line",{"x1":"104.73","y1":"265.41","x2":"104.71","y2":"143.13","fill":"none","stroke":"#231f20","strokeMiterlimit":"10","strokeWidth":"5","key":3}),React.createElement("line",{"x1":"2.51","y1":"195.37","x2":"2.5","y2":"73.09","fill":"none","stroke":"#231f20","strokeMiterlimit":"10","strokeWidth":"5","key":4}),React.createElement("line",{"x1":"104.73","y1":"125.33","x2":"104.72","y2":"3.05","fill":"none","stroke":"#231f20","strokeMiterlimit":"10","strokeWidth":"5","key":5}),React.createElement("line",{"x1":"164.27","y1":"167.05","x2":"164.28","y2":"164.55","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":6}),React.createElement("line",{"x1":"164.29","y1":"158.99","x2":"164.47","y2":"100.61","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.56","key":7}),React.createElement("line",{"x1":"164.48","y1":"97.83","x2":"164.49","y2":"95.33","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":8}),React.createElement("polyline",{"points":"162.33 93.98 164.38 95.42 162.33 96.85","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":9}),React.createElement("line",{"x1":"157.78","y1":"100.03","x2":"109.99","y2":"133.42","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":10}),React.createElement("polyline",{"points":"107.71 135.01 105.67 136.45 103.62 135.01","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":11}),React.createElement("line",{"x1":"99.06","y1":"131.83","x2":"51.27","y2":"98.44","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":12}),React.createElement("polyline",{"points":"49 96.85 46.95 95.42 49 93.98","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":13}),React.createElement("line",{"x1":"53.55","y1":"90.8","x2":"101.34","y2":"57.41","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":14}),React.createElement("polyline",{"points":"103.62 55.82 105.67 54.39 107.71 55.82","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":15}),React.createElement("line",{"x1":"112.27","y1":"59","x2":"160.06","y2":"92.39","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":16}),React.createElement("polyline",{"points":"162.33 165.62 164.38 167.05 162.33 168.48","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":17}),React.createElement("line",{"x1":"157.78","y1":"171.66","x2":"109.99","y2":"205.06","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":18}),React.createElement("polyline",{"points":"107.71 206.65 105.67 208.08 103.62 206.65","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":19}),React.createElement("line",{"x1":"99.06","y1":"203.47","x2":"51.27","y2":"170.07","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":20}),React.createElement("polyline",{"points":"49 168.48 46.95 167.05 49 165.62","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":21}),React.createElement("line",{"x1":"53.55","y1":"162.44","x2":"101.34","y2":"129.04","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":22}),React.createElement("polyline",{"points":"103.62 127.45 105.67 126.02 107.71 127.45","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":23}),React.createElement("line",{"x1":"112.27","y1":"130.63","x2":"160.06","y2":"164.03","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":24}),React.createElement("line",{"x1":"105.67","y1":"208.08","x2":"105.67","y2":"205.58","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":25}),React.createElement("line",{"x1":"105.67","y1":"200.03","x2":"105.67","y2":"141.72","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":26}),React.createElement("line",{"x1":"105.67","y1":"138.95","x2":"105.67","y2":"136.45","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":27}),React.createElement("line",{"x1":"46.97","y1":"167.05","x2":"46.97","y2":"164.55","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":28}),React.createElement("line",{"x1":"46.97","y1":"159","x2":"46.96","y2":"100.69","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","strokeDasharray":"4.63 5.55","key":29}),React.createElement("line",{"x1":"46.96","y1":"97.92","x2":"46.96","y2":"95.42","fill":"none","stroke":"#808285","strokeMiterlimit":"10","strokeWidth":"3","key":30})]))]);
	}
	
	Webpack.displayName = "Webpack";
	
	Webpack.defaultProps = {"viewBox":"0 0 209.64 268.46"};
	
	module.exports = Webpack;
	
	Webpack.default = Webpack;


/***/ }),

/***/ "./src/utils/load-js.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (global, factory) {
	  if ("function" === "function" && ( false ? "undefined" : _typeof(exports)) === "object" && ( false ? "undefined" : _typeof(module)) === "object") {
	    // CommonJS support
	    module.exports = factory();
	  } else if (true) {
	    // Do AMD support
	    //define(["loadJS"], factory);
	  } else {
	    // Do browser support
	    global.loadJS = factory();
	  }
	})(undefined, function () {
	  var cache = {};
	
	  function exec(options) {
	    if (typeof options === "string") {
	      options = {
	        url: options
	      };
	    }
	
	    var id = options.id || options.url;
	    var script = cache[id];
	
	    if (script) {
	      console.log('load-js cache hit', id);
	      return script;
	    }
	
	    if (!options.url && !options.text) {
	      throw new Error("must provide a url or text to load");
	    }
	
	    script = document.createElement("script");
	    script.charset = options.charset || "utf-8";
	    script.type = options.type || "text/javascript";
	    script.async = !!options.async;
	    script.id = id;
	
	    if (options.createFunc) {
	      options.createFunc(script);
	    }
	
	    var head = document.getElementsByTagName("head")[0] || document.documentElement;
	    var pending;
	
	    if (options.url) {
	      script.src = options.url;
	      pending = loadScript(head, script);
	    } else {
	      script.text = options.text;
	      pending = runScript(head, script);
	    }
	
	    if (options.cache !== false && id) {
	      cache[id] = pending;
	    }
	
	    return pending;
	  }
	
	  function runScript(head, script) {
	    head.appendChild(script);
	    return Promise.resolve(script);
	  }
	
	  function loadScript(head, script) {
	    return new Promise(function (resolve) {
	      // Handle Script loading
	      var done = false;
	
	      // Attach handlers for all browsers
	      //
	      // References:
	      // http://stackoverflow.com/questions/4845762/onload-handler-for-script-tag-in-internet-explorer
	      // http://stevesouders.com/efws/script-onload.php
	      //
	      script.onload = script.onreadystatechange = function () {
	        if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
	          done = true;
	
	          // Get the module id that just finished and load it up!
	          // var loadedSrc = script.getAttribute("src");
	
	          // Handle memory leak in IE
	          script.onload = script.onreadystatechange = null;
	          resolve(script);
	        }
	      };
	
	      head.appendChild(script);
	    });
	  }
	
	  return function load(items) {
	    return items instanceof Array ? Promise.all(items.map(exec)) : exec(items);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a677884d00374d12e8b8.js